import { ArrowCircleRightTwoTone } from "@mui/icons-material";
import React, {
  useState,
  useEffect,
  useRef,
  useLayoutEffect,
  useCallback,
  useMemo,
} from "react";
import { useParams, useLocation } from "react-router-dom";
import APIRequest from "../../../services/services";
import Page from "../../Page";
import likeUnlike from "../../../assets/images/Rpost/review.png";
import likelike from "../../../assets/images/Rpost/Rdocs-like.png";
import Unlike from "../../../assets/images/Rpost/Rdocs-Dislike.png";
import Confidential from "../../../assets/images/Rpost/confidential.png";
import print from "../../../assets/images/Rpost/time2.png";
import HeaderWithMobileDesign from "../../../Shared/Header/Default/HeaderWithMobileDesign";
import PdfImg from "../../../assets/images/u70.png";
import RdocsWhite from "../../../../src/assets/images/RDocs-White.png";
import RpostPowered from "../../../../src/assets/images/RPost-powered.png";
import timerpng from "../../../assets/images/Rpost/time2.png";
import Footer from "../../../Shared/Footer/Default/Footer";
import Alert from "../../Controls/Alerts/Alerts";
import "./DocumentRPD.css";
import { useNavigate } from "react-router-dom";
import LoadingSpinner from "../../Controls/LoadingSpinner/LoadingSpinner";
import TimerDisplay from "../../../components/Controls/TimerComponent/TimerDisplay";
import moment from "moment";
import { useCookies } from "react-cookie";
import { Translations } from "../../../Shared/Translation/Translations";
import DocPage from "../../DocPage";
import { Zoom } from "@mui/material";
import styled from "@emotion/styled";
import WhitePage from "../../Controls/PageCreation/WhitePage";
import RequestAccess from "../../../Shared/Modals/RequestAccess.js";
import {
  useDocumentProtection,
  ProtectionOverlay,
  CaptureWarning,
  Watermark,
  AuditEvents,
  parseRShieldPayload,
} from "../../Controls/DocumentProtection";
import { useSelector } from "react-redux";
import {
  clearInterval,
  clearTimeout,
  setInterval,
  setTimeout,
} from "worker-timers";
import SimpleExcelViewer from "../Document/SimpleExcelViewer";
let browserName = "";
let tempRecipientId = 0;
let documentName = "";
let timerCount = 0;
let rdocsLevel = "";
let handleClose = 0;
let readerPageUrl = "/read/";
let max_count = 900;
let waitcount = 0;
let randomNumRpost = Math.floor(Math.random() * 90000) + 10000;
let SessionpopuupDisable = 0,
  noInternetval = 0;
let NoInternetRemainingVal = 0;
let tCount = 0;
let imgSetTimer;
let currentGlobalpage;

const DocumentPageContainer = styled.div({
  width: "100%",
  marginTop: "62px",
  padding: "0px",
  paddingTop: "65px",
  paddingBottom: "5px",
});
function DocumentNew({ translationsMap: langTranslations }) {
  const pageNumberRef = useRef(1);
  const disableMoniterOnPageRestricted = useRef(false);
  let translationsMap = useSelector(
    (state) => state?.languageTranslation?.translationsMap
  );
  if (translationsMap && Object.keys(translationsMap).length === 0) {
    translationsMap = langTranslations ? { ...langTranslations } : {};
  }
  let start = 0;
  let lastVote = -1;
  let sharevoting = 0;
  const [show, setShow] = useState(false);
  const [currentpage, setPage] = useState(1);
  const [currentTempPage, setTempPage] = useState("1");
  const [zoomClass, setZoomClass] = useState("rm-transform1");
  const [zoomClassHeight, setZoomClassHeight] = useState("");
  const [zoomClassFull, setZoomClassFull] = useState("");
  const [zoomClassDiv, setZoomClassDiv] = useState("");
  const [zoomClassDisabled, setZoomClassDisabled] = useState("");
  const [zoomText, setZoomText] = useState("100%");
  const [zoomValue, setZoomValue] = useState(6);
  const [zoomPercentage, setZoomPercentage] = useState(100);
  const [excelZoomScale, setExcelZoomScale] = useState(1);
  const [Loadingmessage, setLoadingmessage] = useState(0);
  const zoomOptions = [
    "100%",
    "100%",
    "100%",
    "50%",
    "75%",
    "100%",
    "125%",
    "150%",
  ];
  const [totalPages, setTotalPages] = useState(1);
  let totalPagesCount = 1;
  const [count, setCount] = useState(0);
  const [countOffLineOnline, setCountOffLineOnline] = useState(0);
  const { documentId, openId } = useParams();
  const [showSlide, setShowResults] = React.useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [open, setOpen] = useState(false);
  const [imgURL, setImgURL] = useState("");
  const imgURLDataArray = useRef([]);
  const [imgURLData, setImgURLData] = useState("");
  const [isExcelFile, setIsExcelFile] = useState(false);
  const isExcelRef = useRef(isExcelFile);
  const [isLevelOne, setLevelOne] = useState(false);
  const [approvedPages, setApprovedPages] = useState([]);

  useEffect(() => {
    isExcelRef.current = isExcelFile;
  }, [isExcelFile]);

  // When the current page is an Excel file, Fit Page and Full Width are not
  // applicable. If either was previously selected, reset zoom to 100%.
  useEffect(() => {
    if (isExcelFile) {
      const mode = zoomModeRef.current;
      if (mode === "FitPage" || mode === "FullWidth") {
        zoomModeRef.current = null;
        setZoomValue(6);
        setZoomText("100%");
        setExcelZoomScale(1);
      }
    }
  }, [isExcelFile]);
  const [excelFileDetails, setExcelFileDetails] = useState(null);
  const excelFileDetailsRef = useRef(null);
  const excelPayloadByPageRef = useRef({});
  const [excelPayloadVersion, setExcelPayloadVersion] = useState(0);
  const [pageLevelRestriction, setPageLevelRestriction] = useState(false);
  const [pageRestrictedCount, setPageRestrictedCount] = useState(0);
  const [pageRestrictedFlag, setPageRestrictedFlag] = useState(false);
  const [localPageLevelRestriction, setLocalPageLevelRestriction] = useState(false);
  const [documentLevelRestriction, setDocumentLevelRestriction] = useState(false);
  const [documentLevelRestrictionDetails, setDocumentLevelRestrictionDetails] = useState([]);
  useEffect(() => {
    const allowRequestAccessForCurrentPage = documentLevelRestrictionDetails.some(
      (item) =>
        (item.pages || []).includes(Number(currentpage)) &&
        item.allowAccessRequest === true
    );
    setAllowRequestAccess(allowRequestAccessForCurrentPage);
  }, [currentpage, documentLevelRestrictionDetails]);
  const [documentpageLevelRestrictionDeclined, setDocumentpageLevelRestrictionDeclined] = useState([]);
  // Per-page Request Access status returned by the server in the page-0 image
  // response, e.g. [{ pages: [2,3,4,5], status: "Pending" }, ...].
  // Used to swap the locked-page overlay's Request Access button with a status
  // message ("Your request is under review" / "Your request is declined").
  const [documentPageLevelRestrictionRequested, setDocumentPageLevelRestrictionRequested] = useState([]);
  const [isNoUnitsPopup, setIsNoUnitsPopup] = useState(false);
  const [pageDataVersion, setPageDataVersion] = useState(0);

  // Request Access state
  const [showRestrictedPopup, setShowRestrictedPopup] = useState(false);
  // Once the user has successfully submitted a Request Access for this document,
  // we hide the Request Access button on the locked-page overlay.
  const [requestAccessDone, setRequestAccessDone] = useState([]);
  const requestAccessRef = useRef();
  const stopIndicatorRef = useRef(false);

  const [imgBlankData] = useState("iVBORw0KGgoAAAANSUhEUgAAA1cAAAI6CAYAAADL37LAAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADr8AAA6/ATgFUyQAAAxeSURBVHhe7dexAYAwDMCwlP9/hg58EI/S4ht83msAAABYef4CAACwYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAIGCuAAAAAuYKAAAgYK4AAAAC5goAACBgrgAAAALmCgAAYG3mA7NDCHAch4InAAAAAElFTkSuQmCC");
  const idleTimeRef = useState(null);
  const [docNote, setDocNote] = useState("");
  const [senderEmailAddress, setSenderEmailAddress] = useState("");
  const [loginEmailAddress, setLoginEmailAddress] = useState("");
  const [userlist, setUserList] = useState([]);
  const [sendEmailButton, setSendEmailButton] = useState("");
  const [identifyLeakerText, setIdentifyLeakerText] = useState("");
  const [identifyLeakerLoopCount, setIdentifyLeakerLoopCount] = useState([
    0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20,
    21, 22, 23, 24, 25, 26, 27, 28, 29, 30,
  ]);
  const [isSideNoteOpened, setisSideNoteOpened] = useState(true);
  const [identifyLeakerEmailLoopCount, setIdentifyLeakerEmailLoopCount] =
    useState([0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15]);
  const [isDistributionList, setisDistributionList] = useState(false);
  const [isSideNote, setisSideNote] = useState(false);
  const [isVoting, setisVoting] = useState(false);
  const [openVoting, setOpenVoting] = useState(false);
  const [lastVoting, setlastVoting] = useState(false);
  const [recipientId, setrecipientId] = useState("");
  const [isVoted, setisVoted] = useState(false);
  const [VotedValue, setVotedValue] = useState(-1);
  const [issharevoting, setsharevoting] = useState(false);
  const [isPrint, setisPrint] = useState(false);
  // const [maxPrintsPerReader, setMaxPrintsPerReader] = useState(null);
  // const [maxPrintsPerDocument, setMaxPrintsPerDocument] = useState(null);
  // const [printCountReader, setPrintCountReader] = useState(0);
  // const [printCountDocument, setPrintCountDocument] = useState(0);
  const [showPrintLimitPopup, setShowPrintLimitPopup] = useState(false);
  const [printLimitMessage, setPrintLimitMessage] = useState("");
  const [isLeftOutMessage, setIsLeftOutMessage] = useState(false);
  const [printData, setPrintData] = useState(null);
  const [allowResponsesTo, setAllowResponsesTo] = useState("");
  const [isallowResponsesTo, setisAllowResponsesTo] = useState(false);
  const [defaultToAddress, setdefaultToAddress] = useState("");
  const [pageWidthValue, setpageWidthValue] = useState("");
  const [pageHeightValue, setpageHeightValue] = useState("");
  const [orignalPageWidth, setOrignalPageWidth] = useState("");
  const [orignalPageHeight, setOrignalPageHeight] = useState("");
  const [orignalMainPageWidth, setOrignalMainPageWidth] = useState("");
  const [orignalMainPageHeight, setOrignalMainPageHeight] = useState("");

  const [pageWidthLeftValue, setpageWidthLeftValue] = useState("");
  const pageRef = useRef(null);
  const initialPageDimensions = useRef({ width: 0, height: 0 });
  const isZoomingRef = useRef(false);
  const [replySubject, setreplySubject] = useState("");
  const [replymessage, setreplymessage] = useState("");
  const [alertMsg, setAlertMsg] = useState("");
  const [alertType, setAlertType] = useState("");
  const [isSessionId, setisSessionId] = useState(false);
  const navigate = useNavigate();
  const [Senderaddressitems, setItems] = useState([]);
  const componentRef = useRef();
  const excelViewerRef = useRef(null);
  // True while the Excel web-edit viewer has UNSAVED cell edits — used to
  // warn before page navigation remounts the viewer and drops them.
  const excelEditsDirtyRef = useRef(false);
  const confirmLeaveUnsavedExcelEdits = () => {
    if (!excelEditsDirtyRef.current) return true;
    const protectionOn = documentProtection && documentProtection.active;
    if (protectionOn) documentProtection.beginInAppAction("ConfirmDialog", 30000);
    let proceed = false;
    try {
      proceed = window.confirm(
        "You have unsaved Excel edits on this page. If you leave without clicking Save, your changes will be lost.\n\nLeave this page anyway?"
      );
    } finally {
      if (protectionOn) documentProtection.endInAppAction();
    }
    if (proceed) excelEditsDirtyRef.current = false;
    return proceed;
  };
  const [pdfViewData, setpdfData] = useState("");
  const [modelopen, setMpdelOpen] = useState(false);
  const [modelMessage, setModelMessage] = useState("");
  const [defaultSubject, setdefaultSubject] = useState("");
  const [openLoader, setOpenLoader] = useState(false);
  const [disablePageNavigationButtons, setDisablePageNavigationButtons] =
    useState(false);
  const [PageviewModelOpen, setPageviewModelOpen] = useState(false);
  const [timerValue, settimerValue] = useState("5 minute(s) & 00 second(s).");
  const [languageTranslations, setLanguageTranslations] = [];
  const [imageResolution, setImageResolution] = useState(150);
  const restrictedImageResolution = useRef(150);
  const [allowAccessRequest, setAllowRequestAccess] = useState(false);

  useEffect(() => {
    const disableBrowserPrint = !isPrint;
    document.body.classList.toggle("rdocs-disable-print", disableBrowserPrint);
    return () => {
      document.body.classList.remove("rdocs-disable-print");
    };
  }, [isPrint]);

  const [Reader_DocumentID, setReader_DocumentID] = useState("");
  const [Reader_EmailAdress, setReader_EmailAdress] = useState("");
  const [Reader_VerificationCode, setReader_VerificationCode] = useState("");
  const [Reader_VerificationCode_Header, setReader_VerificationCode_Header] =
    useState("");
  const [Reader_Authorize, setReader_Authorize] = useState("");
  const [Reader_VerificationCode_Message, setReader_VerificationCode_Message] =
    useState("");
  const [Reader_ClickHere, setReader_ClickHere] = useState("");
  const [Reader_AuthorizeFailure, setReader_AuthorizeFailure] = useState("");
  const [Reader_GetVerificationCode, setReader_GetVerificationCode] =
    useState("");
  const [
    Reader_VerificationCode_Instruction,
    setReader_VerificationCode_Instruction,
  ] = useState("");
  const [
    Reader_VerificationCode_Remember,
    setReader_VerificationCode_Remember,
  ] = useState("");
  const [Reader_PleaseGoBack, setReader_PleaseGoBack] = useState("");
  const [Reader_Submit, setReader_Submit] = useState("");
  const [Reader_ActualSize, setReader_ActualSize] = useState("");
  const [Reader_FitPage, setReader_FitPage] = useState("");
  const [Reader_FullWidth, setReader_FullWidth] = useState("");
  const [Reader_DistributionList, setReader_DistributionList] = useState("");
  const [Reader_SideNote, setReader_SideNote] = useState("");
  const [Reader_ReplyToOwner, setReader_ReplyToOwner] = useState("");
  const [Reader_Print, setReader_Print] = useState("");
  const [Reader_Zoom, setReader_Zoom] = useState("");
  const [Reader_EnterYourEmailAddress, setReader_EnterYourEmailAddress] =
    useState("");
  const [Reader_Email, setReader_Email] = useState("");
  const [Reader_Passcode, setReader_Passcode] = useState("");
  const [Reader_OK, setReader_OK] = useState("");
  const [Reader_Getpasscode, setReader_Getpasscode] = useState("");
  const [Reader_GetPasscode, setReader_GetPasscode] = useState("");
  const [
    Reader_EnterYourEmailAddressCode,
    setReader_EnterYourEmailAddressCode,
  ] = useState("");
  const [Reader_Cancel, setReader_Cancel] = useState("");
  const [Reader_DocumentExpired, setReader_DocumentExpired] = useState("");
  const [Reader_FailedVerifyCodeEmail, setReader_FailedVerifyCodeEmail] =
    useState("");
  const [Reader_Continue, setReader_Continue] = useState("");
  const [Reader_GeneralTermsFooter, setReader_GeneralTermsFooter] =
    useState("");
  const [Reader_GeneralTerms, setReader_GeneralTerms] = useState("");
  const [Reader_Patent, setReader_Patent] = useState("");
  const [Reader_CheckYourEmail, setReader_CheckYourEmail] = useState("");
  const [Reader_APasscodeEmailed, setReader_APasscodeEmailed] = useState("");
  const [Reader_AVerificationCodeEmailed, setReader_AVerificationCodeEmailed] =
    useState("");
  const [Reader_TryAgain, setReader_TryAgain] = useState("");
  const [Reader_DocumentRestrictedAccess, setReader_DocumentRestrictedAccess] =
    useState("");
  const [Reader_ReachedMaximumViews, setReader_ReachedMaximumViews] =
    useState("");
  const [
    Reader_DocumentIsNoLongerAvailable,
    setReader_DocumentIsNoLongerAvailable,
  ] = useState("");
  const [
    Reader_InactivityYourSessionWillEnd,
    setReader_InactivityYourSessionWillEnd,
  ] = useState("");
  const [Reader_Minutes, setReader_Minutes] = useState("");
  const [Reader_Seconds, setReader_Seconds] = useState("");
  const [Reader_SessionTimedOut, setReader_SessionTimedOut] = useState("");
  const [Reader_YouHaveBeenInactive, setReader_YouHaveBeenInactive] =
    useState("");
  const [Reader_RPDYouHaveBeenInactive, setReader_RPDYouHaveBeenInactive] =
    useState("");
  const [Reader_ContinueReadingDocument, setReader_ContinueReadingDocument] =
    useState("");
  const [
    Reader_PrintingDocumentIsNotPermitted,
    setReader_PrintingDocumentIsNotPermitted,
  ] = useState("");
  const [Reader_ConfirmYourVote, setReader_ConfirmYourVote] = useState("");
  const [Reader_OnlyVoteOnce, setReader_OnlyVoteOnce] = useState("");
  const [Reader_Like, setReader_Like] = useState("");
  const [Reader_Dislike, setReader_Dislike] = useState("");
  const [Reader_Voting, setReader_Voting] = useState("");
  const [Reader_ProtectedDocument, setReader_ProtectedDocument] = useState("");
  const [Reader_ProtectedDocumentAccess, setReader_ProtectedDocumentAccess] =
    useState("");
  const [Reader_AllRightsReserved, setReader_AllRightsReserved] = useState("");
  const [Reader_Terms, setReader_Terms] = useState("");
  const [
    Reader_DocumentServerUnavailable,
    setReader_DocumentServerUnavailable,
  ] = useState("");
  const [
    Reader_InternetConnectionRequired,
    setReader_InternetConnectionRequired,
  ] = useState("");
  const [
    Reader_EnteredEmailIsNotReadersList,
    setReader_EnteredEmailIsNotReadersList,
  ] = useState("");
  const [Reader_FailedSendVerifyCode, setReader_FailedSendVerifyCode] =
    useState("");
  const [Reader_UserVerificationFailure, setReader_UserVerificationFailure] =
    useState("");
  const [Reader_DocName, setReader_DocName] = useState("");
  const [Reader_ID, setReader_ID] = useState("");
  const [Reader_EnterEmailGetPasscode, setReader_EnterEmailGetPasscode] =
    useState("");
  const [Reader_PleaseEnterSubject, setReader_PleaseEnterSubject] =
    useState("");
  const [Reader_EmailSuccessfullySent, setReader_EmailSuccessfullySent] =
    useState("");
  const [Reader_DigitalRightsManagement, setReader_DigitalRightsManagement] =
    useState("");
  const [Reader_ProtectedDocumentViewer, setReader_ProtectedDocumentViewer] =
    useState("");
  const [Reader_ViewDistributionList, setReader_ViewDistributionList] =
    useState("");
  const [Reader_UsersList, setReader_UsersList] = useState("");
  const [Reader_ViewSideNote, setReader_ViewSideNote] = useState("");
  const [Reader_NoteFrom, setReader_NoteFrom] = useState("");
  const [Reader_ReplyToDocument, setReader_ReplyToDocument] = useState("");
  const [Reader_ClickToPrint, setReader_ClickToPrint] = useState("");
  const [Reader_Send, setReader_Send] = useState("");
  const [Reader_Message, setReader_Message] = useState("");
  const [Reader_Subject, setReader_Subject] = useState("");
  const [Reader_ToAddress, setReader_ToAddress] = useState("");
  const [Reader_YouWillLoggedIn, setReader_YouWillLoggedIn] = useState("");
  const [Reader_ClickToVote, setReader_ClickToVote] = useState("");
  const [Reader_DocumentHasNoAccess, setReader_DocumentHasNoAccess] =
    useState("");
  const [Reader_AccessDocument, setReader_AccessDocument] = useState("");
  const [
    Reader_SessionExpiredAccessDocument,
    setReader_SessionExpiredAccessDocument,
  ] = useState("");
  const [Reader_PleaseTryAgain, setReader_PleaseTryAgain] = useState("");
  const [Reader_CheckYourConnection, setReader_CheckYourConnection] =
    useState("");
  const [Reader_LegalNotices, setReader_LegalNotices] = useState("");
  const [Reader_ClickServiceLevelTerms, setReader_ClickServiceLevelTerms] =
    useState("");
  const [Reader_OtherService, setReader_OtherService] = useState("");
  const [Reader_InternetConnectProblem, setReader_InternetConnectProblem] =
    useState("");
  const [
    Reader_ConnectivityReauthenticate,
    setReader_ConnectivityReauthenticate,
  ] = useState("");
  const [Reader_AuthenticatingPleaseWait, setReader_AuthenticatingPleaseWait] =
    useState("");
  const [
    Reader_RequestingPassCodePleaseWait,
    setReader_RequestingPassCodePleaseWait,
  ] = useState("");
  const [
    Reader_ReplyToDocumentPleaseWait,
    setReader_ReplyToDocumentPleaseWait,
  ] = useState("");
  const [Reader_PrintDocumentPleaseWait, setReader_PrintDocumentPleaseWait] =
    useState("");
  const [
    Reader_NavigatingBnPagesPleaseWait,
    setReader_NavigatingBnPagesPleaseWait,
  ] = useState("");
  const [API_SubjectMsg, setAPI_SubjectMsg] = useState("");
  const [Reader_EmailBodyMsg, setReader_EmailBodyMsg] = useState("");
  const [Reader_NoUnitbalanceMessage, setReader_NoUnitbalanceMessage] =
    useState("");
  const [Reader_BotInfoMessage, setReader_BotInfoMessage] = useState("");
  const [Reader_robot, setReader_robot] = useState("");
  const [Reader_BotVerifiedMessage, setReader_BotVerifiedMessage] =
    useState("");
  const [Reader_Botverified, setReader_Botverified] = useState("");
  const [Reader_YouDontHaveAccess, setReader_YouDontHaveAccess] = useState("");
  const [Reader_YouDontHaveAccessToRequested, setReader_YouDontHaveAccessToRequested] = useState("");
  const [timerText, settimertimerText] = useState("You will be logged out in ");
  const [Reader_viewTime, setReader_viewTime] = useState("");
  const Container = DocumentPageContainer;
  const [onlineStatus, setOnlineStatus] = useState(true);
  const [noInternetImg, setnoInternetImg] = useState(
    "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"
  );
  const [imgLockData] = useState("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");
  const [minutesVal, setMinutesVal] = useState(0);
  const [secondsVal, setSecondsVal] = useState(0);

  const [idLeakersType, setIdLeakersType] = useState(""); const [Reader_secondsSmall, setReader_secondsSmall] = useState("");

  const [Reader_minutesSmall, setReader_minutesSmall] = useState("");
  const [Reader_YouWillbeLoggedOutIn, setReader_YouWillbeLoggedOutIn] =
    useState("");
  const [Reader_AllowedPagesOnly, setReader_AllowedPagesOnly] =
    useState("");
  const [Reader_SendingYourReply, setReader_SendingYourReply] = useState("");
  const [Reader_LoadingPleaseWait, setReader_LoadingPleaseWait] = useState("");
  const totalPagesRef = useRef();
  let logout = true,
    logoutWarnTime = 300,
    timer;
  let isSessionEndedForUser = false;
  const timeTrackRef = useRef(null);
  const timeTrackBackRef = useRef(null);
  const timeTrackYouDontHaveAccessRef = useRef(null);
  const [Reader_RPostviewTime, setRPostReader_viewTime] = useState("");
  window.history.forward();
  const [showTab, setShowTab] = useState(true);
  const [floatingKey, setFloatingKey] = useState(0);
  const containerRef = useRef(null);
  const floatingPollRef = useRef(null);
  const floatingRef = useRef(null);
  const watermarkStyles = useRef("");
  const isSteganography = useRef(false);
  const [pendingCount, setPendingCount] = useState(0);
  const startLoading = () => setPendingCount(prev => prev + 1);
  const stopLoading = () => setPendingCount(prev => Math.max(prev - 1, 0));
  const pageLocks = useRef({});
  const latestRequestId = useRef(0);
  const abortControllers = useRef({});
  const pageDimensionsRef = useRef({});
  const zoomModeRef = useRef(null);

  const [pageEmails, setPageEmails] = useState({});
  const [submittedRequestEmail, setSubmittedRequestEmail] = useState("");
  const [isVerified, setisVerified] = useState(false);
  const [PasscodeType, setPasscodeType] = useState("password");
  const [passcode, setPasscode] = useState("");
  const [pageRequestStatus, setPageRequestStatus] = useState({});
  const currentEmail = submittedRequestEmail || pageEmails[currentpage] || "";
  const [pageStatus, setPageStatus] = useState("");

  // --- RShield: Browser-Based Document Protection (DocumentRPD only) ---
  // Driven per document by the RShield options the sender chose on the
  // Send / Generate tab. When the document was not sent with RShield, `active`
  // is false and every underlying control is inert, so existing DocumentRPD
  // behavior is unchanged.
  // Print-attempt notice: a modal that stays visible until the reader clicks OK.
  const [printNoticeOpen, setPrintNoticeOpen] = useState(false);
  const handleProtectionEvent = useCallback((event) => {
    if (event === AuditEvents.PRINT_ATTEMPT) {
      setPrintNoticeOpen(true);
    }
  }, []);

  // RShield settings for THIS document, as configured by the sender on the
  // Send / Generate tab. Populated from the /docs/rpddata response below.
  // Stays null when the response carries no RShield information, in which case
  // the legacy per-email AppContext config applies exactly as before.
  const [rShieldSettings, setRShieldSettings] = useState(null);

  const [isContentReady, setIsContentReady] = useState(false);
  useEffect(() => {
    if (isContentReady) return;
    if (imgURLData !== "" || isExcelFile) setIsContentReady(true);
  }, [isContentReady, imgURLData, isExcelFile]);

  const documentProtection = useDocumentProtection({
    email: loginEmailAddress,
    containerRef,
    documentId,
    sessionId: sessionStorage.getItem("session_" + documentId) || "",
    openId,
    pageNumber: currentpage,
    onRedirect: (redirectUrl) => {
      clearTimerAndInterval();
      window.open(redirectUrl, "_self");
    },
    rShield: rShieldSettings,
    translations: translationsMap,
    documentName,
    contentReady: isContentReady,
    onEvent: handleProtectionEvent,
  });
  const requiresFullScreenRef = useRef(false);
  const hasEnteredFullScreenRef = useRef(false);
  const firstPageRecordedRef = useRef(false);

  useEffect(() => {
    requiresFullScreenRef.current =
      documentProtection.active === true &&
      !!documentProtection.config &&
      documentProtection.config.resumeOnFullScreen === true;

    if (
      documentProtection.isFullscreen === true &&
      !hasEnteredFullScreenRef.current
    ) {
      hasEnteredFullScreenRef.current = true;
      // Time accrued behind the overlay is not reading time - drop it rather
      // than posting it on the first /docs/track call after this point.
      tCount = 0;
    }
  }, [
    documentProtection.active,
    documentProtection.config,
    documentProtection.isFullscreen,
  ]);

  const isReadTrackingBlocked = () =>
    requiresFullScreenRef.current === true &&
    hasEnteredFullScreenRef.current !== true;

  const isReadTrackingBlockedRef = useRef(isReadTrackingBlocked);
  isReadTrackingBlockedRef.current = isReadTrackingBlocked;

  useEffect(() => {
    if (!requiresFullScreenRef.current) return;
    if (documentProtection.isFullscreen !== true) return;
    if (firstPageRecordedRef.current) return;
    firstPageRecordedRef.current = true;
    ValidatePageViewAccess(currentGlobalpage || 0, false, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentProtection.isFullscreen]);

  const wasViewingRef = useRef(true);
  useEffect(() => {
    if (!documentProtection.active) return;

    const requiresFullScreen =
      documentProtection.config &&
      documentProtection.config.resumeOnFullScreen === true;

    const isViewing =
      !documentProtection.isBlurred &&
      !documentProtection.isRevoked &&
      (!requiresFullScreen || documentProtection.isFullscreen === true);

    if (isViewing === wasViewingRef.current) return;
    wasViewingRef.current = isViewing;

    if (isViewing) {
      startTimmer();
    } else {
      stopTimmer();
    }
  }, [
    documentProtection.active,
    documentProtection.isBlurred,
    documentProtection.isRevoked,
    documentProtection.isFullscreen,
    documentProtection.config,
  ]);

  useEffect(() => {
    if (pendingCount > 0)
      setOpenLoader(true);
    else setOpenLoader(false);
  }, [pendingCount]);

  useEffect(() => {
    if (!floatingPollRef.current && !isExcelFile) {
      floatingPollRef.current = setInterval(() => {
        // Safe access to the current state without stale closures
        if (isExcelRef.current) return;

        if (disableMoniterOnPageRestricted.current === false) {
          const parent = containerRef.current;
          const node = floatingRef.current;
          if (!parent || !node || !parent.contains(node)) {
            console.log("floatingText not found");
            setShowTab(true);
            setFloatingKey((k) => k + 1);
          } else {
            const style = window.getComputedStyle(node);
            let changeOfStyles = false;
            if (document.querySelector('.watermark') == null && isSteganography.current) {
              setShowTab(true);
              setFloatingKey((k) => k + 1);
              return;
            }
            const watermarkStyle = document.querySelector('.watermark')?.style?.cssText?.replace(/animation\s*:[^;]+;/i, '') || '';
            let currentStyles = watermarkStyles.current.replace(/\n/g, '').replace(/\s{2,}/g, ' ').replace(/animation\s*:[^;]+;/i, '').trim();

            if (watermarkStyle && currentStyles !== watermarkStyle.trim()) {
              changeOfStyles = true;
            }

            if (style.display === 'none' || style.visibility === 'hidden' || style.opacity === '0' || node.id !== 'floatingText') {
              console.log("floatingText not found or hidden");
              changeOfStyles = true;
            }

            if (changeOfStyles) {
              setShowTab(true);
              setFloatingKey((k) => k + 1);
            }
          }
        }
      }, 1000);
    }

    return () => {
      if (floatingPollRef.current && !isExcelFile) {
        clearInterval(floatingPollRef.current);
        floatingPollRef.current = null;
      }
    };
  }, []);

  useEffect(() => {
    window.addEventListener("popstate", (e) => {
      window.history.go(1);
    });
  }, []);

  useEffect(() => { }, [identifyLeakerText]);
  //useEffect(() => {alert(window.innerHeight +" width"+window.innerWidth) }, [identifyLeakerText]);
  useEffect(() => {
    const init = async () => {
      if (imgURL == "") {
        try {
          startLoading();
          setLoadingmessage(0);
          const isValid = await ValidatePageViewAccess(
            0,
            false,
            !requiresFullScreenRef.current
          );
          if (isValid != false) {
            setIsNoUnitsPopup(false);
          }
          else {
            setIsNoUnitsPopup(true);
          }
          handlePageNavigation(0, 5, false);
          loadNextPreviousPages(0);
        }
        catch {

        }
        finally {
          stopLoading()
        }
      }
    }
    async function runInitialSetup() {
      await getRpddata();
      await init();
    }
    runInitialSetup();

  }, []);

  window.addEventListener("popstate", (e) => {
    window.history.go(0);
  });

  useEffect(() => {
    window.addEventListener("offline", () => {
      setOnlineStatus(false);
      noInternetval = 1;
    });

    window.addEventListener("online", () => {
      setOnlineStatus(true);
      noInternetval = 0;
    });
  }, []);

  useEffect(() => {
    var sessionStartDate = null;

    document.addEventListener(
      "visibilitychange",
      function () {
        if (document.hidden && document.visibilityState == "hidden")
          sessionStartDate = new Date();
        else if (
          !document.hidden &&
          document.visibilityState == "visible" &&
          sessionStartDate != null
        ) {
          var sessionEndDate = new Date();
          var difference = (sessionEndDate - sessionStartDate) / 1000 / 2;
          timerCount = timerCount + difference;
          //console.log(timerCount);
        }
      },
      false
    );

    // }
    startTimer();
    // Use capture phase (true) so scroll events from nested scrollable
    // containers (e.g. the Excel grid wrapper) are also caught, since
    // scroll events do NOT bubble.
    document.addEventListener(
      "scroll",
      function () {
        resetTimer();
      },
      true
    );
    // Wheel events DO bubble, but adding a listener ensures mouse-wheel
    // activity inside the Excel viewer resets the session timer as well.
    document.addEventListener(
      "wheel",
      function () {
        resetTimer();
      },
      { passive: true }
    );
    // Mouse activity inside the Excel viewer (cell selection, resizing)
    document.addEventListener(
      "mousedown",
      function () {
        resetTimer();
      },
      false
    );
    // Mouse movement (cursor moving over the page) — ensures the inactivity
    // popup does not appear while the user is actively moving the mouse.
    document.addEventListener(
      "mousemove",
      function () {
        resetTimer();
      },
      false
    );
    // Key-up events — covers all keyboard activity including arrow keys,
    // Tab, Escape, etc. that may not trigger keypress.
    document.addEventListener(
      "keyup",
      function () {
        resetTimer();
      },
      false
    );
    window.oncontextmenu = function (e) {
      // Allow right-click for OnlyOffice Excel viewer (it needs it for cell context menus)
      //if (isExcelFile) return;
      e.preventDefault();
    };
    document.onkeydown = function (e) {
      resetTimer();
      var key = e.key || e.keyCode;
      var alt = document.all ? e.altKey : e.modifiers & e.ALT_MASK;
      key = window.event.keyCode;

      if ((e.ctrlKey || e.metaKey) && (key === 80 || key === 112)) {
        e.preventDefault();
        return false;
      }
      if (window.event.altKey && key == 70) {
        e.preventDefault();
      }

      if (
        key == "F12" ||
        (key == 9 && SessionpopuupDisable == 1) ||
        noInternetval == 1
      ) {
        return false;
      } else if (key == 123) {
        return false;
      } else if (
        (e.ctrlKey && e.shiftKey && key == 73) ||
        (e.ctrlKey && e.shiftKey && key == 74)
      ) {
        return false;
      }
    };
    document.addEventListener(
      "keypress",
      function (event) {
        resetTimer();
        var key = event.key || event.keyCode;

        if (key == 123) {
          return false;
        } else if (
          (event.ctrlKey && event.shiftKey && key == 73) ||
          (event.ctrlKey && event.shiftKey && key == 74)
        ) {
          return false;
        }
      },
      false
    );

    document.onkeypress = function (event) {
      event = event || window.event;
      if (event.keyCode == 123) {
        return false;
      } else if (
        (event.ctrlKey && event.shiftKey && event.keyCode == 73) ||
        (event.ctrlKey && event.shiftKey && event.keyCode == 74)
      ) {
        return false;
      }
    };
    try {
      startLoading();
      let localSessionId = sessionStorage.getItem("session_" + documentId);
      if (localSessionId == "" || localSessionId == null) {
        setisSessionId(false);
        const url = `${process.env.REACT_APP_API}/status/${documentId}`;
        fetch(url, {
          method: "Get",
          headers: {
            "Content-Type": "application/json",
          },
        })
          .then((response) => response.json())
          .then((result) => {
            let type = result.data.documentType;
            let fileName = result.data.fileName;
            if (type == 1) {
              navigate(`/Xerox/ReaderAccess/${documentId}/${fileName}`);
            } else {
              navigate(`/Default/ReaderAccess/${documentId}/${fileName}`);
            }
          });
      } else {
        if (!navigator.onLine) {
          navigate(`/Default/NoInternet/${documentId}`);
        }
        setisSessionId(true);
      }
      localStorage.setItem("openId", openId);
      // if (
      //   sessionStorage.getItem("session_" + documentId) != "" &&
      //   sessionStorage.getItem("session_" + documentId) != null
      // ) {
      //   getRpddata();
      // }
    }
    catch {
    }
    finally {
      stopLoading();
    }
  }, [documentId]);

  // Show request access popup when page level restriction is active
  useEffect(() => {
    if (pageLevelRestriction) {
      setShowRestrictedPopup(true);
    } else {
      setShowRestrictedPopup(false);
    }
  }, [pageLevelRestriction]);

  useEffect(() => {
    if (timeTrackYouDontHaveAccessRef.current) {
      clearTimeout(timeTrackYouDontHaveAccessRef.current);
      timeTrackYouDontHaveAccessRef.current = true;
    }
    timeTrackYouDontHaveAccessRef.current = setTimeout(() => {
      if (pageRestrictedCount > 1 && pageRestrictedFlag == true) {
        setPageRestrictedCount(pageRestrictedCount - 1);
      }
      else {
        setPageRestrictedFlag(false);
        setPageRestrictedCount(0);
      }
    }, 1000);
  }, [pageRestrictedCount]);
  useEffect(() => {
    if (timeTrackBackRef.current) {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
    timeTrackBackRef.current = setInterval(TimeCalulation, 1000);
    return () => {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
  }, []);
  useEffect(() => {
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
    timeTrackRef.current = setInterval(() => {
      check(60, "", true);
    }, 60000);
    return () => {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
  }, []);
  const waitForLock = (pageIndex, flag) => {
    return new Promise(resolve => {
      const interval = setInterval(() => {
        if (!pageLocks.current[pageIndex]) {
          clearInterval(interval);
          resolve();
          if (!flag) {
            stopLoading()
          }
        }
      }, 50); // check every 50 ms
    });
  };
  const handleChkChange = (e) => {
    setLocalPageLevelRestriction(e.target.checked)
  }
  function TimeCalulation() {
    if (tCount > 60) {
      tCount = 0;
    }
    tCount = tCount + 1;
  }
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      //check(tCount, currentGlobalpage);
      if (isReadTrackingBlockedRef.current()) return;
      if (
        sessionStorage.getItem("session_" + documentId) != "" &&
        sessionStorage.getItem("session_" + documentId) != null &&
        window.location.href.toLowerCase().indexOf(readerPageUrl) > -1
      ) {
        if (waitcount == 0 && noInternetval == 0) {
          if (timeTrackRef.current) {
            clearInterval(timeTrackRef.current);
            timeTrackRef.current = null;
          }

          //console.log(pageNumber);
          start += 1;
          let count = start;
          const url = `${process.env.REACT_APP_API}/docs/track1`;
          handleClose = 0;
          var rpdreadInfo = {
            documentId: documentId,
            id: openId,
            ActivityTime: tCount == undefined ? 60 : tCount,
            client: browserName,
            RecipientId: tempRecipientId,
            CurrentPage: !currentGlobalpage ? pageNumberRef.current : currentGlobalpage,
            VersionNumber: Number(localStorage.getItem("DocumentVersion_" + documentId)),
            UserSessionId: localStorage.getItem("local_" + documentId)
          };
          const success = navigator.sendBeacon(
            url,
            JSON.stringify(rpdreadInfo)
          );

          // Log if the beacon was queued for sending
          if (success) {
            console.log("Beacon queued successfully");
          } else {
            console.log("Beacon failed to queue");
          }
        }
      }
      return; // For older browsers
    };
    // Add the event listener
    window.addEventListener("beforeunload", handleBeforeUnload);
    // Clean up the event listener on component unmount
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const updateDimensions = () => {
    try {
      startLoading();
      if (isZoomingRef.current) return;
      const body = document.body;
      if (!pageRef.current || !body) return;

      let naturalW, naturalH, mainWidth, mainHeight;

      if (pageRef.current) {
        const pageInfo = pageRef.current;
        mainWidth = body.clientWidth;
        mainHeight = body.clientHeight - 63 - 102;
        setOrignalMainPageWidth(mainWidth);
        setOrignalMainPageHeight(mainHeight);

        naturalW = pageRef.current?.naturalWidth || pageInfo.clientWidth;
        naturalH = pageRef.current?.naturalHeight || pageInfo.clientHeight;
      }
      if (
        initialPageDimensions.current.width === 0 ||
        initialPageDimensions.current.height === 0 ||
        initialPageDimensions.current.width !== naturalW ||
        initialPageDimensions.current.height !== naturalH
      ) {
        initialPageDimensions.current = { width: naturalW, height: naturalH };
      }

      const { width: pageInfoWidth, height: pageInfoHeight } = initialPageDimensions.current;
      const activeImageResolution = restrictedImageResolution.current;
      const calsPercentageFromResolution =
        activeImageResolution === 300 ? 0.375 : activeImageResolution === 200 ? 0.563 : 0.75;

      const flagHightAdjustment = body.clientWidth < 568;

      const calsPercentage = body.clientWidth - pageInfoWidth < 0
        ? body.clientWidth / pageInfoWidth
        : 1;

      const scale = (calsPercentageFromResolution === 1 || flagHightAdjustment)
        ? calsPercentage
        : calsPercentageFromResolution;

      const scaledWidth = scale * pageInfoWidth;
      const scaledHeight = scale * pageInfoHeight;

      const minPx = 64;
      const maxDisplayWidth = Math.max(0, body.clientWidth - 2 * minPx);
      const displayWidth = Math.min(scaledWidth, maxDisplayWidth);
      const widthScale = displayWidth / (scaledWidth || 1);
      const displayHeight = scaledHeight * widthScale;
      setOrignalPageWidth(displayWidth);
      setOrignalPageHeight(displayHeight);
      setpageWidthValue(displayWidth);
      setpageHeightValue(displayHeight);
      setpageWidthLeftValue((body.clientWidth - displayWidth) / 2);
      // setZoomValue(6);
      // setZoomPercentage(100);
      // setZoomText("100%");
      pageDimensionsRef.current[pageNumberRef.current] = {
        width: displayWidth,
        height: displayHeight,
        left: (body.clientWidth - displayWidth) / 2,
      };
      applyZoomForCurrentPage && applyZoomForCurrentPage(mainHeight);
    } catch {
    } finally {
      stopLoading();
    }
  };
  useEffect(() => {
    const mainPageInfo = document.body;
    if (mainPageInfo) {
      mainPageInfo.style.backgroundColor = "#d2d3d7";
    }
    setZoomValue(6);
    setZoomPercentage(100);
    setZoomText("100%");
    const handleResize = () => {
      isZoomingRef.current = false;
      if (pageRef.current?.complete) {
        updateDimensions();
      }
    };
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);


  async function getRpddata() {
    startLoading();
    try {
      if (
        sessionStorage.getItem("session_" + documentId) != "" &&
        sessionStorage.getItem("session_" + documentId) != null
      ) {
        browserName = getBrowserName();
        //console.log(browserName);
        //console.log("testing");

        //console.warn("when rpddata/ called " + new Date());
        const url = `${process.env.REACT_APP_API}/docs/rpddata/${documentId}/${openId}`;
        //getLanguageTranslations();
        try {
          await fetch(url, {
            method: "GET",
            mode: "cors",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((response) => response.json())
            .then((data) => {
              let constUserList = "";
              if (data != null && data != "" && data.authenticated) {
                clearTimerAndInterval();
                window.open(data.redirectUrl, "_self");
              }
              if (data?.data?.versionNumber != null) {
                localStorage.setItem("DocumentVersion_" + documentId, data.data.versionNumber.toString());
              }
              documentName = data?.data?.fileName;
              rdocsLevel = data?.data?.levelValue;
              // RShield - per document settings chosen by the sender on the
              // Send / Generate tab. parseRShieldPayload returns null when the
              // response has no RShield fields (older API build), and in that
              // case the existing protection behavior is left untouched.
              const rShieldFromApi = parseRShieldPayload(data);
              if (rShieldFromApi) {
                setRShieldSettings(rShieldFromApi);
                requiresFullScreenRef.current =
                  rShieldFromApi.enabled === true &&
                  !!rShieldFromApi.options &&
                  rShieldFromApi.options.resumeOnFullScreen === true;
              }
              //Voting
              if (data && data.data != null && data.data?.isVoting) {
                setisVoting(data.data?.isVoting);
              }
              if (data?.data?.isVoteSharing) {
                setsharevoting(data?.data?.isVoteSharing);
              }
              if (
                data?.data?.isVoting &&
                data?.data?.votingValue != -1 &&
                data?.data?.votingValue != null
              ) {
                setVotedValue(data.data.votingValue);
                setisVoting(true);
                setisVoted(true);
              }
              //distributionList
              if (
                data &&
                data.data != null &&
                data.data?.isDistributionList &&
                data.data?.recipients &&
                data.data?.recipients.length > 0
              ) {
                setisDistributionList(true);
                //console.log("userlist" + data.data.recipients);
              }
              if (data?.data?.excelPageConfigs) {
                //setExcelFileDetails(data?.data?.excelPageConfigs);
                excelFileDetailsRef.current = data?.data?.excelPageConfigs;
              } else {
                //setExcelFileDetails(null);
                excelFileDetailsRef.current = null;
              }
              //side note
              if (data != null && data.data != null) {
                setisPrint(data.data?.isCanPrint);
                // setMaxPrintsPerReader(data.data?.maxPrintsPerReader ?? null);
                // setMaxPrintsPerDocument(data.data?.maxPrintsPerDocument ?? null);
                // setPrintCountReader(data.data?.currentPrintCountReader ?? 0);
                // setPrintCountDocument(data.data?.currentPrintCountDocument ?? 0);
                setSenderEmailAddress(data.data?.senderEmailAddress);
                setLoginEmailAddress(data.data?.emailAddress);
                setTotalPages(data.data?.pages);
                totalPagesCount = data.data?.pages;
                setImageResolution(data.data?.imageResolution);
                restrictedImageResolution.current = data.data?.imageResolution;
                setUserList(data.data?.recipients);

                if (
                  JSON.parse(data.data?.sideNote) != null &&
                  JSON.parse(data.data?.sideNote) != ""
                ) {
                  setDocNote(JSON.parse(data.data?.sideNote));
                  setisSideNote(true);
                  if (rdocsLevel === "1") {
                    const alreadyOpenedThisSession = sessionStorage.getItem("sideNoteOpened_" + openId + "_" + documentId);
                    if (alreadyOpenedThisSession === null) {
                      setisSideNoteOpened(false);
                      sessionStorage.getItem("sideNoteOpened_" + openId + "_" + documentId, false);
                    }
                    else {
                      setisSideNoteOpened(alreadyOpenedThisSession == "false" ? false : true);
                    }
                  }
                  else {
                    setisSideNoteOpened(data?.data?.isSideNoteOpened);
                  }
                }
              }
              //stegabigraphy
              if (
                data &&
                data.data != null &&
                data.data?.isSteganography &&
                data.data?.emailAddress
                //&& !isExcelFile
              ) {
                console.log(data.data?.isSteganography);
                isSteganography.current = true;
                let concEmails = "";
                let concEmailsSets = "";
                identifyLeakerEmailLoopCount.map((item) => {
                  concEmails =
                    concEmails +
                    "&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;" +
                    data.data.emailAddress;
                });

                identifyLeakerLoopCount.map((item) => {
                  concEmailsSets =
                    concEmailsSets + "<div>" + concEmails + "</div>";
                });
                //setIdentifyLeakerText(concEmailsSets);
                // Mapping helpers
                const fontSizeMap = {
                  Small: "10px",
                  Medium: "12.5px",
                  Large: "15px",
                };

                const speedMap = {
                  "0.5x": "20s",
                  "1x": "10s",
                  "2x": "5s",
                };

                function FloatingText(docSettings) {
                  const fontSizeMap = { Small: "10px", Medium: "12.5px", Large: "15px" };
                  const speedMap = { "0.5x": "20s", "1x": "10s", "2x": "5s" };

                  const prefix = docSettings?.suffixPrefixFloating === "Prefix"
                    ? `<b><i>${docSettings?.suffixPrefixFloatingText}</i></b> `
                    : "";

                  const suffix = docSettings?.suffixPrefixFloating === "Suffix"
                    ? ` <b><i>${docSettings?.suffixPrefixFloatingText}</i></b>`
                    : "";

                  const baseText = `${prefix}${docSettings?.floatingText}${suffix}`.trim();

                  let repeatedRow = "";
                  for (let i = 0; i < 100; i++) repeatedRow += `&nbsp;&nbsp;&nbsp;&nbsp;${baseText}`;

                  let repeatedGrid = "";
                  for (let j = 0; j < 100; j++) repeatedGrid += `<div style="height:60px">${repeatedRow}</div>`;

                  const watermarkStyle = `
                  width: 2400px;
                  position: absolute;
                  animation: ${docSettings?.navigation == "TopLefttoBottomRight" ? "floatAnim" : "floatAnimr"} ${speedMap[docSettings.speed] || "10s"} linear infinite alternate;
                  transform: rotateZ(${docSettings?.navigation == "TopLefttoBottomRight" ? "45deg" : "-45deg"});
                  margin-left: ${docSettings?.navigation == "TopLefttoBottomRight" ? "-2800px" : "-1200px"};
                  margin-top: ${docSettings?.navigation == "TopLefttoBottomRight" ? "-1000px" : "-400px"};
                  font-size: ${fontSizeMap[docSettings?.fontSize] || "10px"};
                  color: ${docSettings?.fontColor.toLowerCase()};
                  opacity: ${parseFloat(docSettings?.floatingOpacity)};
                  pointer-events: none;
                `;
                  watermarkStyles.current = watermarkStyle;

                  return `<div className="watermark noselect" style="${watermarkStyle}">${repeatedGrid}</div>`;
                }
                let finalResult = FloatingText(data.data.docSettings);
                setIdentifyLeakerText(finalResult);
              }
              setrecipientId(data.data.recipientId);
              //console.log(data.data.recipientId);
              tempRecipientId = data.data.recipientId;
              setisAllowResponsesTo(true);

              if (
                data.data.allowResponsesTo != null &&
                data.data.allowResponsesTo != ""
              ) {
                setItems(data.data.allowResponsesTo.split(","));
                setdefaultToAddress(data.data.allowResponsesTo.split(",")[0]);
                setAllowResponsesTo(data.data.allowResponsesTo.split(",")[0]);
              }

              setreplySubject(""); //data.data.subject
              setdefaultSubject(""); //data.data.subject
            });
        } catch (error) {
          console.log(error);
          return () => { };
        }
      }
    } catch {
    } finally {
      stopLoading();
    }
  }

  function getBrowserName() {
    var ua = navigator.userAgent,
      tem,
      M =
        ua.match(
          /(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i
        ) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edg)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(" ");
  }
  async function check(TimeinSeconds, currPageNum, IsAutoInvoke, stopFlag) {
    //console.log(" TimeinSeconds: " + TimeinSeconds + " currPageNum: " + currPageNum + " IsAutoInvoke: " + IsAutoInvoke + " stopFlag: " + stopFlag);
    if (isReadTrackingBlockedRef.current()) return;
    if (
      sessionStorage.getItem("session_" + documentId) != "" &&
      sessionStorage.getItem("session_" + documentId) != null &&
      window.location.href.toLowerCase().indexOf(readerPageUrl) > -1
    ) {
      if (waitcount == 0 && noInternetval == 0) {
        if ((IsAutoInvoke === true && TimeinSeconds >= 60) || !IsAutoInvoke) {
          if (timeTrackRef.current) {
            clearInterval(timeTrackRef.current);
            timeTrackRef.current = null;
          }
          if (!stopFlag) {
            timeTrackRef.current = setInterval(function () {
              check(60, "", true);
            }, 60000);
          }
          tCount = 0;

          //console.log(pageNumber);
          start += 1;
          let count = start;
          const url = `${process.env.REACT_APP_API}/docs/track`;
          handleClose = 0;
          var rpdreadInfo = {
            documentId: documentId,
            id: openId,
            ActivityTime: TimeinSeconds == undefined ? 60 : TimeinSeconds,
            client: browserName,
            RecipientId: tempRecipientId,
            CurrentPage: !currPageNum ? pageNumberRef.current : currPageNum,
            VersionNumber: Number(localStorage.getItem("DocumentVersion_" + documentId)),
            UserSessionId: localStorage.getItem("local_" + documentId)
          };

          await fetch(url, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(rpdreadInfo),
          })
            .then((response) => response.json())
            .then((response) => {
              if (response.authenticated) {
                clearTimerAndInterval();
                if (
                  response.message != null &&
                  response.message === "declined"
                ) {
                  localStorage.setItem("DeclinedVar_" + documentId, "true");
                } else {
                  localStorage.setItem("DeclinedVar_" + documentId, "false");
                }
                window.open(response.redirectUrl, "_self");
                // const redirectPath = new URL(response.redirectUrl).pathname;
                // console.log("translationsMap", translationsMap);
                // navigate(redirectPath, {
                //   replace: true,
                //   state: {
                //     translationsMap: { ...translationsMap }
                //   }
                // });
              }
              //console.log(response);
            })
            .catch((error) => {
              console.log("Document read error");
            });
          start = 0;
          waitcount = 0;
          //console.log(count);
        }
      }
    }
  }
  function startTimer() {
    logout = true;
    timerCount = 0;
    localStorage.setItem("timerCountRPD" + randomNumRpost, 0);
    //max_count = 900; //1800
    startCount();
  }

  function startCount() {
    timer = setTimeout(function () {
      startCount();
    }, 1000);

    logout = true;
    var remaining_time = 0;

    if (noInternetval == 0) {
      localStorage.setItem(
        "timerCountRPD" + randomNumRpost,
        parseInt(localStorage.getItem("timerCountRPD" + randomNumRpost)) + 1
      );
      timerCount = timerCount + 1;

      //var remaining_time = max_count - timerCount;
      remaining_time =
        max_count -
        parseInt(localStorage.getItem("timerCountRPD" + randomNumRpost));
      NoInternetRemainingVal = remaining_time;
    } else {
      remaining_time = NoInternetRemainingVal;
    }

    if (remaining_time <= 0 && logout && !isSessionEndedForUser) {
      //waitcount = 1;
      SessionpopuupDisable = 0;
      isSessionEndedForUser = true;
      setOpen(false);
      resetTimer();
      localStorage.removeItem(
        localStorage.getItem("timerCountRPD" + randomNumRpost)
      );
      check(tCount);
      clearTimerAndInterval();
      localStorage.setItem(`FileName${documentId}`, documentName);
      navigate(
        `/Default/SessionExpireMessage/${documentId}/${rdocsLevel}/${documentName}`
      );
      return;
    } else if (remaining_time < logoutWarnTime) {
      SessionpopuupDisable = 1;
      var tempTime = moment.duration(remaining_time, "s");

      setMinutesVal(tempTime.get("minutes"));
      setSecondsVal(tempTime.get("seconds"));
      setOpen(true);
      stopTimmer();
      waitcount = 1;
    } else {
      setOpen(false);
    }
  }
  function resetTimer() {
    if (SessionpopuupDisable == 1) {
      setOpen(true);
    } else {
      setOpen(false);

      logout = false;
      waitcount = 0;
      isSessionEndedForUser = false;
      timerCount = 0;
      localStorage.setItem("timerCountRPD" + randomNumRpost, 0);
      settimerValue("5 minute(s) & 00 second(s)");
    }
  }

  function steg(steg) {
    let id = null;
    const elem = document.getElementById(steg);

    let pos = 1;
    id = setInterval(frame, 200);
    var rect = document.getElementById("page").getBoundingClientRect();
    console.log("page boundingclient :" + rect);
    console.log(
      "top :" + Math.floor(Math.random() * rect.height) + rect.top + 50 + "px"
    );
    console.log(
      "left :" +
      Math.floor(Math.random() * rect.width) +
      (rect.left - 40) +
      "px"
    );
    elem.style.top =
      Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
    elem.style.left =
      Math.floor(Math.random() * rect.width) + (rect.left - 40) + "px";
    function frame() {
      var eTop = parseInt(elem.style.top, 10);
      var eLeft = parseInt(elem.style.left, 10);
      if (document.getElementById("page") != null) {
        var rect = document.getElementById("page").getBoundingClientRect();
        console.log("frame page boundingclient :" + rect);
        if (eTop > rect.bottom - 100 || eLeft > rect.left + rect.width - 100) {
          elem.style.top =
            Math.floor(Math.random() * rect.height) + rect.top + 50 + "px";
          elem.style.left = rect.left - 40 + "px";
          console.log(
            "frame page boundingclient top :" +
            Math.floor(Math.random() * rect.height) +
            rect.top +
            50 +
            "px"
          );
          console.log(
            "frame page boundingclient left :" + rect.left - 40 + "px"
          );
        } else {
          elem.style.top = eTop + pos + "px";
          console.log(
            "frame page boundingclient top else :" + eTop + pos + "px"
          );
          console.log(
            "frame page boundingclient left else :" + eLeft + pos + "px"
          );
          elem.style.left = eLeft + pos + "px";
        }
      }
    }
  }
  function clearTimerAndInterval() {
    clearTimeout(timer);
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
  }
  const ValidatePageViewAccess = async (cPage, flag, recordPageView = true) => {
    try {
      if (totalPagesCount == 1 && totalPages > 0) {
        totalPagesCount = totalPages;
      }
      console.log("cPage in ValidatePageViewAccess " + cPage + " " + totalPagesCount + " " + totalPages);
      if (cPage >= totalPagesCount)
        return;
      //startLoading();
      let finalReturn = true;
      resetTimer();
      const versionNumber = localStorage.getItem("DocumentVersion_" + documentId);
      const userSessionId = localStorage.getItem("local_" + documentId);
      const url = `${process.env.REACT_APP_API}/docs/ValidatePageViewAccess/${documentId}/${cPage}/${openId}/${flag}` + `?VersionNumber=${versionNumber}&UserSessionId=${encodeURIComponent(userSessionId)}&recordPageView=${recordPageView !== false}`;
      const res = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });
      const response = await res.json();
      // .then((response) => response.json())
      // .then((response) => {
      setIdLeakersType(response?.data?.iDLeakersTypeValue);
      setLevelOne(response?.level1Authenticated);
      const approvedPagesResponse = response.approvedPages || [];
      setApprovedPages(approvedPagesResponse);
      if (
        response.authenticated &&
        response.sucess == "true" &&
        response.redirectUrl != null &&
        response.redirectUrl != ""
      ) {
        clearTimerAndInterval();
        window.open(response.redirectUrl, "_self");
        return false;
      } else if (response.errorCode == "RD001") {
        return (finalReturn = false);
      }
      else if (
        response.authenticated &&
        response.sucess == "false" &&
        response.redirectUrl != null &&
        response.redirectUrl != ""
      ) {
        clearTimerAndInterval();
        if (response.message != null && response.message == "declined") {
          localStorage.setItem("DeclinedVar_" + documentId, "false");
        } else {
          localStorage.setItem("DeclinedVar_" + documentId, "true");
        }

        window.open(response.redirectUrl, "_self");
        return false;
      } else if (
        response.authenticated &&
        response.sucess == "true" &&
        response.redirectUrl == null
      ) {
        return finalReturn;
      } else {
        setOpenVoting(true);
        return finalReturn;
      }
      return finalReturn;
    }
    catch {

    }
    finally {
      //stopLoading();
    }
  };
  const handleKeyDownPageNumChange = (event) => {
    if (event.key === 'Enter') {
      totalPagesRef.current?.blur();
    }
  };
  const handleBlurPageNumChangeWrapper = async () => {
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(currentTempPage)) {
        handleBlurPageNumChange();
      }
      else {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        setTempPage(currentGlobalpage);
        totalPagesRef.current?.blur();
      }
    }
    else
      handleBlurPageNumChange();
  }
  const handleBlurPageNumChange = async () => {
    if (currentTempPage === "") {
      setTempPage(currentGlobalpage);
      totalPagesRef.current?.blur();
      return; // Early return if the page is empty
    }
    if (
      currentTempPage != "" &&
      currentGlobalpage != parseInt(currentTempPage) &&
      !confirmLeaveUnsavedExcelEdits()
    ) {
      setTempPage(currentGlobalpage);
      totalPagesRef.current?.blur();
      return; // reader chose to stay and save first
    }
    if (currentTempPage != "" && currentGlobalpage != parseInt(currentTempPage)) {
      let page = currentTempPage;
      //setOpenLoader(true);
      setDisablePageNavigationButtons(true);
      resetTimer();
      if (page === "" || page === null) {
        setTempPage("");
        //setOpenLoader(false);
        return;
      }
      page = parseInt(page);
      if (!isNaN(page) && page <= totalPages && page >= 1) {
        let pageIndex = page - 1;
        pageNumberRef.current = pageIndex + 1;
        setLoadingmessage(0);
        if (checkImgDataIsExisted(pageIndex)) {
          const isValid = await ValidatePageViewAccess(pageIndex, true);
          if (isValid != false) {
            setImgDataFromExisted(pageIndex);
            setPage(page);
            currentGlobalpage = page;
            setTempPage(page);
            setIsNoUnitsPopup(false);
          }
          else {
            setTempPage(currentpage);
            currentGlobalpage = currentpage;
            setPage(currentpage);
            pageNumberRef.current = currentpage;
            setDisablePageNavigationButtons(false);
            setIsNoUnitsPopup(true);
            return;
          }
        } else {
          const isValid = await ValidatePageViewAccess(pageIndex, false);
          if (isValid != false) {
            setIsNoUnitsPopup(false);
            handlePageNavigation(pageIndex, 1, false);
          }
          else {
            setTempPage(currentpage);
            currentGlobalpage = currentpage;
            setPage(currentpage);
            pageNumberRef.current = currentpage;
            setDisablePageNavigationButtons(false);
            setIsNoUnitsPopup(true);
            return;
          }
        }
        loadNextPreviousPages(pageIndex);
        check(tCount, currentpage);
      } else {
        setTempPage(pageNumberRef.current);
        //setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      }
    }
    totalPagesRef.current?.blur();
  };
  const handlePageNumChange = (page) => {
    console.log("handle blur");
    if (/^\d*$/.test(page)) {
      setTempPage(page);
    }
  };
  const handleValidatePageLevelRestriction = (
    incrementDecriment,
    curPageNumber
  ) => {

    const isRestrictedPage = (pageNo) => {
      const restricted = documentLevelRestrictionDetails.some(
        (element) => element.pages.includes(pageNo)
      );

      if (isLevelOne && approvedPages.length > 0) {
        const approved = approvedPages.includes(pageNo);
        return restricted && !approved;
      }

      return restricted;
    };

    if (incrementDecriment === "decrement") {
      curPageNumber = curPageNumber - 1;
      for (let index = curPageNumber; index > 0; index--) {
        if (!isRestrictedPage(index)) {
          return index;
        }
      }
      return curPageNumber + 1;
    }
    else {
      curPageNumber = curPageNumber + 1;
      for (let index = curPageNumber; index <= totalPages; index++) {
        if (!isRestrictedPage(index)) {
          return index;
        }
      }
      return curPageNumber - 1;
    }
  }
  const handleValidatePageRestriction = (curPageNumber) => {
    let validateFlag = true;
    documentLevelRestrictionDetails.forEach(element => {
      if (element.pages.includes(parseInt(curPageNumber))) {
        validateFlag = false;
        return false;
      }
    });
    return validateFlag;
  }
  const handleNextChangeWrapper = async (event) => {
    if (!confirmLeaveUnsavedExcelEdits()) return;
    setisVerified(false);
    if (currentpage >= totalPages) {
      return;
    }
    let revicedPage = currentpage;
    if (localPageLevelRestriction) {
      revicedPage = handleValidatePageLevelRestriction("increment", currentpage);
      if (revicedPage == currentpage) {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        return;
      }
      else {
        revicedPage = revicedPage - 1;
      }
    }
    handleNextChange(revicedPage);
  }


  const onProceedHandler = async () => {
    try {
      var rpdPrint = {
        DocumentId: documentId,
        RecpientId: tempRecipientId,
        DocumentLevelRestriction: documentLevelRestriction,
        ChkPageLevelRestriction: localPageLevelRestriction,
        PageLevelRestrictionData: documentLevelRestrictionDetails,
        EmailAddress: loginEmailAddress,
        OpenRecordId: openId,
        IsProceed: true
      };

      const url = `${process.env.REACT_APP_API}/docs/PrintData`;
      const response = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rpdPrint),
      })
      showPrintScreen(printData)
      setShowPrintLimitPopup(false)
    }
    catch (error) {
      console.log("Error in onProceedHandler", error)
    }
  }

  const handleNextChange = async (revicedPage) => {
    // if (handleNextChangeTimeout != undefined)
    //   clearTimeout(handleNextChangeTimeout);
    // if (handleNextChangeCancelRef.current) {
    //   //handleNextChangeCancelRef.current();
    //   clearTimeout(handleNextChangeCancelRef.current);
    // }
    // handleNextChangeCancelRef.current = setTimeout(() => {
    try {
      setDisablePageNavigationButtons(true);
      // (async () => {
      //setOpenLoader(true);
      resetTimer();
      if (totalPages > revicedPage) {
        let pageIndex = revicedPage;
        pageNumberRef.current = pageIndex + 1;
        setLoadingmessage(0);
        if (checkImgDataIsExisted(pageIndex)) {
          const isValid = await ValidatePageViewAccess(pageIndex, true);
          if (isValid != false) {
            setIsNoUnitsPopup(false);
            setImgDataFromExisted(pageIndex);
            setPage(parseInt(pageNumberRef.current));
            currentGlobalpage = parseInt(pageNumberRef.current);
            setTempPage(parseInt(pageNumberRef.current));
          }
          else {
            setTempPage(currentpage);
            currentGlobalpage = currentpage;
            pageNumberRef.current = currentpage;
            setPage(currentpage);
            setDisablePageNavigationButtons(false);
            setIsNoUnitsPopup(true);
            return;
          }
        } else {
          const isValid = await ValidatePageViewAccess(pageIndex, false);
          if (isValid != false) {
            setIsNoUnitsPopup(false);
            handlePageNavigation(pageIndex, 2, false);
          }
          else {
            setTempPage(currentpage);
            currentGlobalpage = currentpage;
            pageNumberRef.current = currentpage;
            setPage(currentpage);
            setDisablePageNavigationButtons(false);
            setIsNoUnitsPopup(true);
            return;
          }
        }
        loadNextPreviousPages(pageIndex);
        check(tCount, revicedPage);
      } else {
        //setOpenLoader(false);
        setDisablePageNavigationButtons(false);
      }
      //}
      // )();
    }
    catch {

    }
    finally {
      setTimeout(() => setDisablePageNavigationButtons(false), 200);
    }

    //},500);
  };

  useEffect(() => {
    return () => {
      if (handleNextChangeCancelRef.current) {
        clearTimeout(handleNextChangeCancelRef.current);
        handleNextChangeCancelRef.current = null;
      }
      if (handlePreviousChangeCancelRef.current) {
        clearTimeout(handlePreviousChangeCancelRef.current);
        handlePreviousChangeCancelRef.current = null;
      }
      if (loadNextPreviousPagesCancelRef.current) {
        loadNextPreviousPagesCancelRef.current();
        loadNextPreviousPagesCancelRef.current = null;
      }
    };
  }, []);

  var handlePreviousChangeTimeout;
  var handleNextChangeTimeout;
  const handleNextChangeCancelRef = useRef(null);
  const handlePreviousChangeCancelRef = useRef(null);
  const loadNextPreviousPagesCancelRef = useRef(null);
  const handlePreviousChangeWrapper = async (event) => {
    if (!confirmLeaveUnsavedExcelEdits()) return;
    setisVerified(false);
    if (currentpage <= 1) {
      return;
    }
    let revicedPage = currentpage;
    if (localPageLevelRestriction) {
      revicedPage = handleValidatePageLevelRestriction("decrement", currentpage);
      if (revicedPage == currentpage) {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
        return;
      }
      else {
        revicedPage = revicedPage + 1;
      }
    }
    handlePreviousChange(revicedPage);
  }
  const handlePreviousChange = async (revicedPage) => {
    // if (handlePreviousChangeTimeout != undefined)
    //   clearTimeout(handlePreviousChangeTimeout);
    // if (handlePreviousChangeCancelRef.current) {
    //   //handlePreviousChangeCancelRef.current();
    //   clearTimeout(handlePreviousChangeCancelRef.current);
    // }
    // handlePreviousChangeCancelRef.current = setTimeout(() => {
    // (async () => {
    setDisablePageNavigationButtons(true);
    //setOpenLoader(true);
    resetTimer();
    if (revicedPage > 1) {
      let pageIndex = revicedPage - 2;
      pageNumberRef.current = pageIndex + 1;
      setLoadingmessage(0);
      if (checkImgDataIsExisted(pageIndex)) {
        const isValid = await ValidatePageViewAccess(pageIndex, true);
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          setImgDataFromExisted(pageIndex);
          setPage(parseInt(pageNumberRef.current));
          currentGlobalpage = parseInt(pageNumberRef.current);
          setTempPage(parseInt(pageNumberRef.current));
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }


      } else {
        const isValid = await ValidatePageViewAccess(pageIndex, false);
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          handlePageNavigation(pageIndex, 3, false);
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }
      }
      loadNextPreviousPages(pageIndex);
      check(tCount, revicedPage);
    } else {
      //setOpenLoader(false);
      setDisablePageNavigationButtons(false);
    }
    // })();
    //},500);
  };


  const handleNextMaxWrap = () => {
    setisVerified(false);
    if (currentpage >= totalPages) {
      return;
    }
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(totalPages)) {
        handleNextMax();
      }
      else {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
      }
    }
    else
      handleNextMax();
  }
  const handleNextMax = async () => {
    setDisablePageNavigationButtons(true);
    //setOpenLoader(true);
    if (currentpage != totalPages) {
      resetTimer();
      let pageIndex = totalPages - 1;
      pageNumberRef.current = totalPages;
      setLoadingmessage(0);
      if (checkImgDataIsExisted(pageIndex)) {
        const isValid = await ValidatePageViewAccess(pageIndex, true);
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          setImgDataFromExisted(pageIndex);
          setPage(parseInt(pageNumberRef.current));
          currentGlobalpage = parseInt(pageNumberRef.current);
          setTempPage(parseInt(pageNumberRef.current));
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }
      } else {
        const isValid = await ValidatePageViewAccess(pageIndex, false);
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          handlePageNavigation(pageIndex, 4, false);
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }
      }
      loadNextPreviousPages(pageIndex);
      check(tCount, currentpage);
    } else {
      //setOpenLoader(false);
      setDisablePageNavigationButtons(false);
    }
  };
  const handlePreviousMinWrap = () => {
    setisVerified(false);
    if (currentpage <= 1) {
      return;
    }
    if (localPageLevelRestriction) {
      if (handleValidatePageRestriction(1)) {
        handlePreviousMin();
      }
      else {
        setPageRestrictedCount(5);
        setPageRestrictedFlag(true);
      }
    }
    else
      handlePreviousMin();
  }
  const handlePreviousMin = async () => {
    setDisablePageNavigationButtons(true);
    //setOpenLoader(true);
    if (currentpage != 1) {
      let pageIndex = 0;
      pageNumberRef.current = pageIndex + 1;
      setLoadingmessage(0);
      if (checkImgDataIsExisted(pageNumberRef.current)) {
        const isValid = await ValidatePageViewAccess(pageIndex, true);
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          setImgDataFromExisted(pageIndex);
          setPage(1);
          currentGlobalpage = 1;
          setTempPage(1);
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }
      } else {
        const isValid = await ValidatePageViewAccess(pageIndex, false);
        debugger;
        if (isValid != false) {
          setIsNoUnitsPopup(false);
          handlePageNavigation(pageIndex, 5, false);
        }
        else {
          setTempPage(currentpage);
          currentGlobalpage = currentpage;
          pageNumberRef.current = currentpage;
          setPage(currentpage);
          setDisablePageNavigationButtons(false);
          setIsNoUnitsPopup(true);
          return;
        }
      }
      loadNextPreviousPages(pageIndex);
      check(tCount, currentpage);
    } else {
      //setOpenLoader(false);
      setDisablePageNavigationButtons(false);
    }
  };

  const handlePageNavigation = async (pageIndex, requestedFrom, flag) => {
    //console.log('handlePageNavigation called');
    if (isZoomingRef.current) isZoomingRef.current = false;
    if (requestedFrom == 1) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag, pageIndex
      );
      pageNumberRef.current = pageIndex + 1;
      setPage(parseInt(pageNumberRef.current));
      currentGlobalpage = parseInt(pageNumberRef.current);
      setTempPage(parseInt(pageNumberRef.current));
    } else if (requestedFrom == 2) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag, pageIndex
      );
      pageNumberRef.current = pageIndex + 1;
      setPage(pageNumberRef.current);
      currentGlobalpage = parseInt(pageNumberRef.current);
      setTempPage(parseInt(pageNumberRef.current));
    } else if (requestedFrom == 3) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag, pageIndex
      );
      pageNumberRef.current = pageIndex + 1;
      setPage(pageNumberRef.current);
      currentGlobalpage = parseInt(pageNumberRef.current);
      setTempPage(parseInt(pageNumberRef.current));
    } else if (requestedFrom == 4) {
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag, pageIndex
      );
      pageNumberRef.current = pageIndex + 1;
      setPage(pageNumberRef.current);
      currentGlobalpage = parseInt(pageNumberRef.current);
      setTempPage(pageNumberRef.current);
    } else if (requestedFrom == 5) {
      resetTimer();
      handleImageData(
        `${process.env.REACT_APP_API}/images/${documentId}/${pageIndex}/${openId}`,
        flag, pageIndex
      );
      pageNumberRef.current = 1;
      setPage(1);
      currentGlobalpage = 1;
      setTempPage(1);
    }
  };

  function scheduleIdle() {
    return new Promise((resolve) => {
      if (typeof window !== "undefined" && "requestIdleCallback" in window) {
        window.requestIdleCallback(() => resolve());
      } else {
        setTimeout(resolve, 0);
      }
    });
  }

  function scheduleCancelableIdle(cb) {
    if (typeof window !== "undefined" && "requestIdleCallback" in window && "cancelIdleCallback" in window) {
      const id = window.requestIdleCallback(cb);
      return () => window.cancelIdleCallback(id);
    } else {
      const id = setTimeout(cb, 0);
      return () => clearTimeout(id);
    }
  }
  const handleImageData = async (url, flag, pageIndex) => {
    if (totalPagesCount == 1 && totalPages > 0) {
      totalPagesCount = totalPages;
    }
    console.log("pageIndex inhandleImageData " + pageIndex + " " + totalPagesCount + " " + totalPages);
    if (abortControllers.current[pageIndex]) {
      abortControllers.current[pageIndex].abort();
    }
    const activeExcelFileDetails = excelFileDetailsRef.current;
    if (activeExcelFileDetails?.length > 0) {
      const excelPageConfig = activeExcelFileDetails.find(x => x.pageNumber == (pageIndex + 1) && x.isExcel == true);
      if (excelPageConfig) {
        // Check if this Excel page is restricted via page-level lock settings.
        // The 1-based page number is used to check against documentLevelRestrictionDetails.
        const excelPageNum = pageIndex + 1;
        let isExcelPageRestricted = false;
        if (localPageLevelRestriction && Array.isArray(documentLevelRestrictionDetails)) {
          documentLevelRestrictionDetails.forEach(element => {
            if (element.pages && element.pages.includes(excelPageNum)) {
              isExcelPageRestricted = true;
            }
          });
        }
        if (!flag) {
          if (isExcelPageRestricted) {
            // Page is locked — show restricted page instead of Excel viewer
            console.log(`[DocumentRPD] Excel page ${excelPageNum} is restricted, showing lock page.`);
            setIsExcelFile(false);
            setPageLevelRestriction(true);
          } else {
            console.log(`[DocumentRPD] handleImageData setting isExcelFile=TRUE for pageIndex=${pageIndex}, flag=${flag}`);
            setIsExcelFile(true);
            setPageLevelRestriction(false);
          }
        }
        if (isExcelPageRestricted) {
          if (!checkImgDataInitiated(pageIndex, true)) {
            console.log(`[DocumentRPD] Adding dummy excel object to cache for pageIndex=${pageIndex}`);
            imgURLDataArray.current.push({ image: "excel", pageNum: pageIndex, pageLevelRestriction: true });
          }
          return;
        }
        if (excelPayloadByPageRef.current[pageIndex]) {
          if (!checkImgDataInitiated(pageIndex, true)) {
            imgURLDataArray.current.push({ image: "excel", pageNum: pageIndex, pageLevelRestriction: false });
          }
          return;
        }
      }
      else if (!flag) {
        console.log(`[DocumentRPD] handleImageData setting isExcelFile=FALSE for pageIndex=${pageIndex}, flag=${flag}`);
        setIsExcelFile(false);
      }
    }

    // Create new controller
    const controller = new AbortController();
    abortControllers.current[pageIndex] = controller;
    if (!checkImgDataIsExisted(pageIndex)) {
      if (!flag) startLoading();
      if (!checkImgDataInitiated(pageIndex, true))
        imgURLDataArray.current.push({ image: "", pageNum: pageIndex, pageLevelRestriction: "" });

      if (imgURLDataArray.current.some(x => x.pageNum === pageIndex && x.image) || pageIndex < 0) { return; }
      const responsed = await fetch(url + "/" + flag + "/true", {
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
      try {
        if (responsed.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else if (responsed.status == 404) {
          return;
        }
        let response;
        if (flag === true) {
          const text = await responsed.text();
          await scheduleIdle();
          response = JSON.parse(text);
        } else {
          response = await responsed.json();
        }
        //console.log(response);
        //console.warn("when image/ responded " + new Date());
        if (
          response.authenticated &&
          response.sucess == "true" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
          return;
        } else if (
          response.authenticated &&
          response.sucess == "false" &&
          response.redirectUrl != null &&
          response.redirectUrl != ""
        ) {
          clearTimerAndInterval();
          window.open(response.redirectUrl, "_self");
          return;
        } else if (response.sucess == "true") {
          if (response.excelData) {
            excelPayloadByPageRef.current = {
              ...excelPayloadByPageRef.current,
              [response.pageNum]: {
                excelData: response.excelData,
                fileType: response.fileType,
                fileName: response.fileName,
              },
            };
            setExcelPayloadVersion((v) => v + 1);
            let excelInArray = false;
            for (let i = 0; i < imgURLDataArray.current.length; i++) {
              const element = imgURLDataArray.current[i];
              if (element.pageNum == response.pageNum) {
                element.image = "excel";
                element.pageLevelRestriction = response.pageLevelRestriction;
                excelInArray = true;
              }
            }
            if (!excelInArray) {
              imgURLDataArray.current.push({
                image: "excel",
                pageNum: response.pageNum,
                pageLevelRestriction: response.pageLevelRestriction,
              });
            }

            if (response.flag != true) {
              setPageLevelRestriction(response.pageLevelRestriction);
              disableMoniterOnPageRestricted.current = response.pageLevelRestriction;
              if (!flag) setDisablePageNavigationButtons(false);
            }
            return;
          }
          if (response.flag != true) {
            setImgURLData(response.image);
            const isPageApproved = (response.approvedPages || approvedPages || []).includes(response.pageNum);
            const finalPageLevelRestriction = isPageApproved ? false : response.pageLevelRestriction;
            setPageLevelRestriction(finalPageLevelRestriction);
            disableMoniterOnPageRestricted.current = finalPageLevelRestriction;
            if (response.pageNum == 0) {
              setDocumentLevelRestriction(response.documentRestriction);
              setDocumentLevelRestrictionDetails(response.documentPageLevelRestrictionDetails);
              setDocumentpageLevelRestrictionDeclined(response.documentpageLevelRestrictionDeclined || []);
              // Capture per-page Request Access status (Pending / Rejected / etc.)
              // shape: [{ pages: [2,3,4,5], status: "Pending" }, ...]
              const requested = Array.isArray(response.documentpageLevelRestrictionRequested)
                ? response.documentpageLevelRestrictionRequested
                : Array.isArray(response.documentPageLevelRestrictionRequested)
                  ? response.documentPageLevelRestrictionRequested
                  : [];
              setDocumentPageLevelRestrictionRequested(requested);
              // If there is at least one Pending or Rejected entry, treat the
              // request as already submitted so the Request Access button is
              // hidden in favor of the status message on the locked-page overlay.
              const hasOpenRequest = requested.some(
                (r) => r && (r.status === "Pending" || r.status === "Rejected")
              );
            }
            let updated = false;
            for (let i = 0; i < imgURLDataArray.current.length; i++) {
              const element = imgURLDataArray.current[i];
              if (element.pageNum == response.pageNum && element.image == "") {
                element.image = response.image;
                element.pageLevelRestriction = response.pageLevelRestriction;
                const neighborDimensions = await calcalateNeighbourPageDimensions(response.image);
                element.Width = neighborDimensions.width;
                element.Height = neighborDimensions.height;
                updated = true;
              }
            }
            if (updated) setPageDataVersion((v) => v + 1);
          } else {
            let updated = false;
            for (let i = 0; i < imgURLDataArray.current.length; i++) {
              const element = imgURLDataArray.current[i];
              if (element.pageNum == response.pageNum && element.image == "") {
                element.image = response.image;
                element.pageLevelRestriction = response.pageLevelRestriction;
                const neighborDimensions = await calcalateNeighbourPageDimensions(response.image);
                element.Width = neighborDimensions.width;
                element.Height = neighborDimensions.height;
                updated = true;
              }
            }
            if (updated) setPageDataVersion((v) => v + 1);
          }
          if (!flag) {
            setDisablePageNavigationButtons(false);
          }
        }
        else {
          setPageviewModelOpen(true);
          setDisablePageNavigationButtons(false);
        }
      } catch (error) {
        console.log("Document read error");
        setDisablePageNavigationButtons(false);
      } finally {
        pageLocks.current[pageIndex] = false;
        if (!flag) stopLoading();
      }
    }
  };

  const calcalateNeighbourPageDimensions = (image) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.onload = function () {
        const body = document.body;
        //const imageResolution = 300;
        const calsPercentageFromResolution =
          restrictedImageResolution.current === 300 ? 0.375 : restrictedImageResolution.current === 200 ? 0.563 : 0.75;

        const flagHightAdjustment = body.clientWidth < 568;

        const calsPercentage = body.clientWidth - img.naturalWidth < 0
          ? body.clientWidth / img.naturalWidth
          : 1;

        const scale = (calsPercentageFromResolution === 1 || flagHightAdjustment)
          ? calsPercentage
          : calsPercentageFromResolution;

        const scaledWidth = scale * img.naturalWidth;
        const scaledHeight = scale * img.naturalHeight;

        const minPx = 64;
        const maxDisplayWidth = Math.max(0, body.clientWidth - 2 * minPx);
        const displayWidth = Math.min(scaledWidth, maxDisplayWidth);
        const widthScale = displayWidth / (scaledWidth || 1);
        const displayHeight = scaledHeight * widthScale;
        resolve({ width: displayWidth, height: displayHeight });
      };
      img.onerror = function () {
        resolve({ width: img.width || 0, height: img.height || 0 });
      };
      img.src = `data:image/png;base64,${image}`;
    });
  }


  const checkImgDataIsExisted = (cPage) => {
    var verifyFlag = false;
    if (imgURLDataArray.current.length == 0) {
      return false;
    }
    imgURLDataArray.current.map((element) => {
      if (parseInt(element.pageNum) == cPage && verifyFlag != true && (element.image || element.pageLevelRestriction)) {
        verifyFlag = true;
      }
    });
    if (verifyFlag) return true;
    else return false;
  };
  const checkImgDataInitiated = (cPage, flag) => {
    let initiated = false;
    imgURLDataArray.current.map((element) => {
      if (element.pageNum == cPage && !initiated) {
        initiated = true;
      }
    });
    return initiated;
  };
  const setImgDataFromExisted = (cPage) => {
    imgURLDataArray.current.map((element) => {
      if (element.pageNum == cPage) {
        setImgURLData(element.image);
        setPageLevelRestriction(element.pageLevelRestriction);
      }
    });

    // Determine whether the cached page is an Excel page or not and toggle
    // isExcelFile accordingly.  Without this, navigating between a cached
    // Excel page and a cached PDF page via the "already-fetched" path would
    // leave isExcelFile stale (e.g. still true when moving to a PDF page,
    // which caused the "Loading Excel…" indicator to flash, or still false
    // when moving back to an Excel page so the viewer never mounted).
    const activeExcelFileDetails = excelFileDetailsRef.current;
    if (activeExcelFileDetails?.length > 0) {
      const pageNum = (parseInt(cPage) || 0) + 1; // cPage is 0-based index
      const isExcel = activeExcelFileDetails.some(
        (x) => x.pageNumber == pageNum && x.isExcel == true
      );
      setIsExcelFile(isExcel);
    } else {
      // No Excel metadata available — the page is a normal image/PDF page.
      setIsExcelFile(false);
    }

    //setOpenLoader(false);
    setDisablePageNavigationButtons(false);
  };

  const loadNextPreviousPages = (cPage) => {
    loadNextPreviousPagesCancelRef.current = scheduleCancelableIdle(async () => {
      var imgArrayListToPull = [];
      if (totalPagesCount == 1 && totalPages > 0) {
        totalPagesCount = totalPages;
      }
      if (totalPagesCount <= 5) {
        if (totalPagesCount == 1) imgArrayListToPull = [0];
        else if (totalPagesCount == 2) imgArrayListToPull = [0, 1];
        else if (totalPagesCount == 3) imgArrayListToPull = [0, 1, 2];
        else if (totalPagesCount == 4) imgArrayListToPull = [0, 1, 2, 3];
        else if (totalPagesCount == 5) imgArrayListToPull = [0, 1, 2, 3, 4];
      }
      // else if (cPage == 0 && totalPagesCount > 5) {
      //   imgArrayListToPull = [1, 2, 3, 4, 5];
      // } else if (cPage == 1 && totalPagesCount > 5) {
      //   imgArrayListToPull = [0, 2, 3, 4, 5];
      // } else if (cPage == totalPagesCount - 1 && totalPagesCount > 5) {
      //   imgArrayListToPull = [
      //     totalPagesCount - 5,
      //     totalPagesCount - 4,
      //     totalPagesCount - 3,
      //     totalPagesCount - 2,
      //   ];
      // } else if (cPage - 1 == totalPagesCount - 1 && totalPagesCount > 5) {
      //   imgArrayListToPull = [
      //     totalPagesCount - 5,
      //     totalPagesCount - 4,
      //     totalPagesCount - 3,
      //     totalPagesCount - 1,
      //   ];
      // } 
      else {
        imgArrayListToPull = generateNumbers(cPage, totalPagesCount);
      }
      for (const element of imgArrayListToPull) {
        if (!checkImgDataIsExisted(element)) {
          if (element !== 1)
            await scheduleIdle();
          // if (rdocsLevel !== "1") {
          //   await handleImageData(
          //     `${process.env.REACT_APP_API}/imageasync/${documentId}/${element}/${openId}`,
          //     true, element
          //   );
          // } else {
          await handleImageData(
            `${process.env.REACT_APP_API}/images/${documentId}/${element}/${openId}`,
            true, element
          );
          // }
        }
      }
    });
  };
  const generateNumbers = (num, totalNumber) => {
    let numbers = [];
    for (let i = 1; i <= 5; i++) {
      let incrementedNumer = num + i;
      let decrementedNumer = num - i;
      if (incrementedNumer < totalNumber && incrementedNumer > 0) numbers.push(incrementedNumer);
      if (decrementedNumer < totalNumber && decrementedNumer > 0) numbers.push(decrementedNumer);
    }
    return numbers;
  };
  const handleToClose = () => {
    SessionpopuupDisable = 0;
    setOpen(false);
    timerCount = 0;
    resetTimer();
    startTimmer();
    handleClose = 0;
    waitcount = 0;
  };

  // Request Access handlers
  const handleRequestAccess = (response = "") => {
    setShowRestrictedPopup(false);
    if (!requestAccessRef.current) return;
    requestAccessRef.current.onShow(
      true,
      documentId,
      {
        Reader_OK: translationsMap.Reader_OK,
        loadingPleaseWait: translationsMap.Reader_LoadingPleaseWait,
        headerText: translationsMap.Reader_RequestAccess,
        readerId: translationsMap.Reader_ID,
      },
      documentLevelRestrictionDetails,
      (isLevelOne) ? response?.requestedPages : documentPageLevelRestrictionRequested,
      documentLevelRestrictionDetails,
      pageEmails[currentpage] || ""
    );
  };

  // Append the just-requested pages with status "Pending" to the in-memory
  // `documentPageLevelRestrictionRequested` so the locked-page overlay shows
  // "Your request is under review" for those pages within the same session,
  // without waiting for a fresh document load.
  const recordPendingRequest = (requestedPages) => {
    const normalized = Array.isArray(requestedPages)
      ? requestedPages.map((p) => parseInt(p, 10)).filter((p) => !isNaN(p))
      : [];
    if (!normalized.length) return;
    setDocumentPageLevelRestrictionRequested((prev) => {
      const existing = Array.isArray(prev) ? prev : [];
      const alreadyTracked = new Set(
        existing.flatMap((r) =>
          r && Array.isArray(r.pages)
            ? r.pages.map((p) => parseInt(p, 10)).filter((p) => !isNaN(p))
            : []
        )
      );
      const newPages = normalized.filter((p) => !alreadyTracked.has(p));
      if (!newPages.length) return existing;
      return [...existing, { pages: newPages, status: "Pending" }];
    });
  };
  const isPageUnderReview = documentPageLevelRestrictionRequested?.some((item) => item.pages?.includes(currentpage));
  const isPageDeclined = documentpageLevelRestrictionDeclined?.includes(currentpage);

  // Fired when user clicks Submit on the Request Access popup.
  // Submits readerEmail (logged-in user), selected restricted pages and documentId.
  // Returns a Promise<{ success: boolean }> so RequestAccess can surface the outcome.
  const onConfirmRequestHandler = (requestDetails) => {
    const url = `${process.env.REACT_APP_API}/docs/PageLevelRequestAccess`;
    const requestedPages = Array.isArray(requestDetails.requestedPages)
      ? requestDetails.requestedPages
      : [];
    const readerNotes = requestDetails.readerNotes
    const rpdInfo = {
      id: documentId,
      email: (loginEmailAddress || pageEmails[currentpage] || "").trim(),
      requestedPages,
      readerNotes,
    };
    setLoadingmessage(3);
    setOpenLoader(true);
    return fetch(url, {
      mode: "cors",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdInfo),
    })
      .then((response) => {
        setOpenLoader(false);
        if (!response.ok) return { success: false };
        return response
          .json()
          .then((data) => {
            setRequestAccessDone((prev) => [...new Set([...prev, ...rpdInfo.requestedPages]),]);
            // Treat the call as successful if the HTTP response is OK and the
            // backend didn't explicitly flag a failure.
            const success = data ? data.success !== false : true;
            if (success) {
              // setRequestAccessDone(true);
              recordPendingRequest(requestedPages);
            }
            return { success };
          })
          .catch(() => {
            // setRequestAccessDone(true);
            recordPendingRequest(requestedPages);
            return { success: true };
          });
      })
      .catch((error) => {
        console.log("Request access error:", error);
        setOpenLoader(false);
        return { success: false };
      });
  };

  // Re-open the locked-page "Request Access" overlay when the user cancels
  // out of the RequestAccess popup.
  const onRequestAccessCancel = () => {
    setShowRestrictedPopup(true);
  };

  const handleRestrictedPopupClose = () => {
    setShowRestrictedPopup(false);
  };

  const stopTimmer = () => {
    if (!stopIndicatorRef.current) {
      stopIndicatorRef.current = true;
      if (timeTrackBackRef.current) {
        clearInterval(timeTrackBackRef.current);
        timeTrackBackRef.current = null;
      }
      console.log("stop :" + timeTrackBackRef.current);
      if (timeTrackRef.current) {
        clearInterval(timeTrackRef.current);
        timeTrackRef.current = null;
      }
      console.log("stop :" + timeTrackRef.current);
      check(tCount, currentGlobalpage, false, true);
    }
  }
  const startTimmer = () => {
    stopIndicatorRef.current = false;
    if (timeTrackBackRef.current) {
      clearInterval(timeTrackBackRef.current);
      timeTrackBackRef.current = null;
    }
    timeTrackBackRef.current = setInterval(TimeCalulation, 1000);
    console.log("start: " + timeTrackBackRef.current);
    if (timeTrackRef.current) {
      clearInterval(timeTrackRef.current);
      timeTrackRef.current = null;
    }
    timeTrackRef.current = setInterval(() => {
      check(60, "", true);
    }, 60000);
    console.log("start: " + timeTrackRef.current);
  }
  const handleSideNoteClick = async () => {
    if (isSideNoteOpened) return;
    setisSideNoteOpened(true);
    sessionStorage.setItem("sideNoteOpened_" + openId + "_" + documentId, true);
    try {
      const url = `${process.env.REACT_APP_API}/docs/sidenoteopened`;
      await fetch(url, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ DocumentId: documentId, OpenId: openId }),
      });
    } catch (e) {
      console.log(e);
    }
  };
  const recordVote = (vote) => {
    lastVote = vote;
    if (vote == 1) setlastVoting(true);
    else setlastVoting(false);

    setOpenVoting(true);
  };
  const handleToLike = async (e) => {
    resetTimer();
    console.log("handleToLike" + recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;

    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 1,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(1);
          setUserList(
            userlist.map((item, idex) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 1 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap", translationsMap);
          navigate(redirectPath, {
            replace: true,
            state: {
              translationsMap: { ...translationsMap }
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res"+response);
  };
  const handleToUnLike = async (e) => {
    resetTimer();
    console.log(recipientId);
    let url = `${process.env.REACT_APP_API + "/docs/vote"}`;
    let data = {
      RecpientId: recipientId,
      DocumentId: documentId,
      vote: 0,
    };
    await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status == 502) {
          window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
          return;
        } else {
          return response.json();
        }
      })
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          setVotedValue(0);
          setUserList(
            userlist.map((item, idex) => {
              if (item.email.toLowerCase() === loginEmailAddress.toLowerCase()) return { ...item, vote: 0 };
              else return { ...item };
            })
          );
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          if (response.message != null && response.message == "declined") {
            localStorage.setItem("DeclinedVar_" + documentId, "false");
          } else {
            localStorage.setItem("DeclinedVar_" + documentId, "true");
          }

          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap", translationsMap);
          navigate(redirectPath, {
            replace: true,
            state: {
              translationsMap: { ...translationsMap }
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
    // var response = await APIRequest.POST(data, url);
    // console.log("res" + response);
  };

  const votingdialogClose = () => {
    lastVote = -1;
    setOpenVoting(false);
  };
  const Validatevoting = async () => {
    const url = `${process.env.REACT_APP_API}/docs/vote`;

    var rpdVoting = {
      DocumentId: documentId,
      RecpientId: recipientId,
      vote: lastVote,
    };

    await fetch(url, {
      method: "POST",
      mode: "cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(rpdVoting),
    })
      .then((response) => response.json())
      .then((response) => {
        console.log(response);
        if (response.status == "200") {
          setisVoting(true);
          setisVoted(true);
          setVotedValue(lastVote);
          lastVote = -1;
          setOpenVoting(false);
        }
        if (response.authenticated) {
          clearTimerAndInterval();
          //window.open(response.redirectUrl, "_self");
          const redirectPath = new URL(response.redirectUrl).pathname;
          console.log("translationsMap", translationsMap);
          navigate(redirectPath, {
            replace: true,
            state: {
              translationsMap: { ...translationsMap }
            }
          });
        }
      })
      .catch((error) => {
        console.log("Document read error");
      });
  };

  const handleMobileZoomDropdown = (e, text, zoomPercentValue) => {
    isZoomingRef.current = true;
    resetTimer();
    if ("scrollRestoration" in navigate) {
      navigate.scrollRestoration = "manual";
    }
    window.scrollTo(0, 0);
    window.history.scrollRestoration = "manual";
    //setZoomClass(" r-transform" + e.target.value);
    setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }
    //  if(parseInt(text) == 50){
    //   setZoomClassHeight(" ")
    //   }
    //   else{
    //     setZoomClassHeight("min-vh-95")
    //   }
    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else if (e.target.value == 7) {
      setZoomClassFull("");
      setZoomClass("rm-transform7");
    } else if (e.target.value == 8) {
      setZoomClassFull("");
      setZoomClass("rm-transform8");
    } else {
      setZoomClassFull("");
      setZoomClass("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      percentageOfPageHeight =
        1 + (orignalMainPageHeight - orignalPageHeight) / orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      let percentageOfPageWidth;
      percentageOfPageWidth =
        0.99 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );

    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text);
    setShow(false);
  };

  const applyZoomForCurrentPage = (availableHeightOverride) => {
    const mode = zoomModeRef.current;
    if (mode !== "FitPage" && mode !== "FullWidth") return;
    const body = document.body;
    if (!body) return;


    const naturalW = Number(initialPageDimensions.current.width) || Number(orignalPageWidth) || 0;
    const naturalH = Number(initialPageDimensions.current.height) || Number(orignalPageHeight) || 0;

    const minPx = 64;
    const maxDisplayWidth =
      mode === "FullWidth"
        ? body.clientWidth
        : Math.max(0, body.clientWidth - 2 * minPx);
    const availableHeight =
      Number.isFinite(Number(availableHeightOverride)) && Number(availableHeightOverride) > 0
        ? Number(availableHeightOverride)
        : orignalMainPageHeight;

    let scale = 1;
    if (mode === "FullWidth") {
      scale = naturalW ? maxDisplayWidth / naturalW : 1;
    } else if (mode === "FitPage") {
      const widthScale = naturalW ? maxDisplayWidth / naturalW : 1;
      const heightScale = naturalH ? availableHeight / naturalH : 1;
      scale = Math.min(widthScale, heightScale);
    }

    const targetWidth = Math.round(naturalW * scale);
    const targetHeight = Math.round(naturalH * scale);
    const left = mode === "FullWidth" ? 0 : (body.clientWidth - targetWidth) / 2;

    setpageWidthValue(targetWidth);
    setpageHeightValue(targetHeight);
    setpageWidthLeftValue(left);

  };


  const restrictedWhitePageCacheRef = useRef({});
  const whitePageDimsRef = useRef({});

  const renderRestrictedWhitePage = () => {
    const curPageNum = Number(currentpage) || 1;
    let curIndex = 0;
    if (curPageNum === 1) {
      curIndex = 1;
    } else {
      curIndex = curPageNum - 2;
    }
    // if(curIndex===-1 && currentpage===1){
    //   curIndex=1;
    // }else if(curIndex<=0){
    //   curIndex=0;
    // }

    const cacheKey = String(curPageNum);
    const cachedElement = restrictedWhitePageCacheRef.current[cacheKey];
    if (cachedElement) return cachedElement;
    const findByIndex = (idx) => {
      let imgItem = imgURLDataArray.current.find((e) => Number(e.pageNum) === Number(idx));
      return imgItem;
    }
    let pageItem = findByIndex(curIndex);
    // if(pageItem && pageItem.image===""){
    //   pageItem=findByIndex(curPageNum-1);
    // }

    const hasDims = (entry) =>
      entry && Number(entry.Width) > 0 && Number(entry.Height) > 0;

    if (hasDims(pageItem)) {

      const prevDims = whitePageDimsRef.current[String(curPageNum - 1)];
      let finalWidth = Number(pageItem.Width);
      let finalHeight = Number(pageItem.Height);
      if (prevDims && prevDims.width > 0 && prevDims.height > 0) {
        finalWidth = prevDims.width;
        finalHeight = prevDims.height;
      }
      const item = { ...pageItem, Width: finalWidth, Height: finalHeight };

      const element = (
        <Container
          className={
            zoomClassFull != ""
              ? " no-visual-search d-flex fixed-postion " + zoomClassFull
              : "no-visual-search d-flex fixed-postion"
          }
        >
          <WhitePage
            imgEntry={item}
            rpdBody={document.getElementById("rpdBody")}
            Reader_YouDontHaveAccess={translationsMap.Reader_YouDontHaveAccess}
          />
        </Container>
      );

      whitePageDimsRef.current[String(curPageNum)] = { width: finalWidth, height: finalHeight };
      restrictedWhitePageCacheRef.current[cacheKey] = element;
      return element;
    }
    return null;
  };

  const handleZoomDropdown = (e, text, zoomPercentValue) => {
    zoomModeRef.current = zoomPercentValue;
    isZoomingRef.current = true;
    resetTimer();

    //setZoomClass(" r-transform" + e.target.value);
    setZoomClassHeight("rpdf-height" + e.target.value);
    console.log("Dropdown Zoom", e.target.value);

    //   if (e.target.value == 3 || e.target.value == 8){
    //     //setZoomClassFull("col-lg-12")
    //   }
    //  else if ( e.target.value == 7){
    //     //setZoomClassFull("col-lg-10")
    //   }
    //   else{
    //     setZoomClassFull("")
    //   }
    //  if(parseInt(text) == 50){
    //   setZoomClassHeight(" ")
    //   }
    //   else{
    //     setZoomClassHeight("min-vh-95")
    //   }
    if (e.target.value == 2) {
      setZoomClassFull("fixed-postion");
    } else if (e.target.value == 7) {
      setZoomClassFull("");
      setZoomClass("rm-transform7");
    } else if (e.target.value == 8) {
      setZoomClassFull("");
      setZoomClass("rm-transform8");
    } else {
      setZoomClassFull("");
      setZoomClass("");
    }
    let zoomperValue = "1";
    if (zoomPercentValue == "0.5") {
      zoomperValue = "0.5";
    } else if (zoomPercentValue == "0.75") {
      zoomperValue = "0.75";
    } else if (zoomPercentValue == "1") {
      isZoomingRef.current = false;
      zoomperValue = "1";
    } else if (zoomPercentValue == "1.25") {
      zoomperValue = "1.25";
    } else if (zoomPercentValue == "1.5") {
      zoomperValue = "1.5";
    } else if (zoomPercentValue == "FitPage") {
      let percentageOfPageHeight;
      let hightAdjustment =
        restrictedImageResolution.current == 300 ? 15 : restrictedImageResolution.current == 200 ? 0 : 0;
      percentageOfPageHeight =
        1 +
        (orignalMainPageHeight - orignalPageHeight + hightAdjustment + 12) /
        orignalPageHeight;
      zoomperValue = percentageOfPageHeight;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    } else if (zoomPercentValue == "FullWidth") {
      isZoomingRef.current = false;
      let percentageOfPageWidth;
      percentageOfPageWidth =
        0.99 + (orignalMainPageWidth - orignalPageWidth) / orignalPageWidth;
      zoomperValue = percentageOfPageWidth;
      text = Math.round(parseFloat(zoomperValue) * 100) + "%";
    }
    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue(
      (orignalMainPageWidth - divImgWidth) / 2 +
      (zoomPercentValue == "FitPage" ? 7 : 0)
    );
    setpageHeightValue(divImgHeight);
    setZoomValue(parseInt(e.target.value));
    setZoomText(text)
    setExcelZoomScale(parseFloat(zoomperValue) || 1);
    setShow(false);
  };

  const handleZoomOut = (e) => {
    isZoomingRef.current = true;
    resetTimer();
    if (SessionpopuupDisable == 1) return false;

    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) tempZoomValue = 5;
    else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 100;

      if (zoomTextVal > 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else if (zoomTextVal > 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal > 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal > 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal > 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else {
        return false;
      }
    } else if (zoomValue !== 4) {
      tempZoomValue = tempZoomValue - 1;
    }
    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    setZoomClassHeight("rpdf-height" + tempZoomValue);
    if (tempZoomValue === 7) {
      zoomperValue = "1.25";
      setZoomClassFull("");
    } else if (tempZoomValue === 6) {
      isZoomingRef.current = false;
      zoomperValue = "1";
      setZoomClassFull("");
    } else if (tempZoomValue === 5) {
      zoomperValue = "0.75";
      setZoomClassFull("");
      //setZoomClassDiv("fixed-postion");
    } else if (tempZoomValue === 4) {
      zoomperValue = "0.5";
      setZoomClassFull("");
    } else {
      setZoomClassFull("");
      setZoomClassDiv("");
    }

    let divImgWidth = Math.round(
      parseInt(orignalPageWidth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(orignalPageHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);
    setExcelZoomScale(parseFloat(zoomperValue) || 1);
    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const handleZoomIn = (e) => {
    isZoomingRef.current = true;
    resetTimer();
    var tempZoomValue = zoomValue;
    let zoomperValue = "1.25";
    if (zoomValue === 1 || zoomValue === 6) {
      tempZoomValue = 7;
    } else if (zoomValue === 2 || zoomValue === 3) {
      let zoomTextVal = zoomText != "" ? zoomText.replace("%", "") : 1;

      if (zoomTextVal < 50) {
        zoomperValue = "0.5";
        tempZoomValue = 4;
      } else if (zoomTextVal < 75) {
        zoomperValue = "0.75";
        tempZoomValue = 5;
      } else if (zoomTextVal < 100) {
        zoomperValue = "1";
        tempZoomValue = 6;
      } else if (zoomTextVal < 125) {
        zoomperValue = "1.25";
        tempZoomValue = 7;
      } else if (zoomTextVal < 150) {
        zoomperValue = "1.5";
        tempZoomValue = 8;
      } else {
        return false;
      }
    } else if (zoomValue == 5) {
      zoomperValue = "1";
      setZoomClassFull("");
      tempZoomValue = tempZoomValue + 1;
    } else if (zoomValue !== 8) {
      tempZoomValue = tempZoomValue + 1;
    }

    //computeFittingZoomGivenDimensions(false,false,window.innerWidth,window.innerHeight,pageInfo.width,pageInfo.height,zoomperValue);
    if (zoomValue == 4) {
      zoomperValue = "0.75";
      setZoomClassFull("");
    } else if (zoomValue == 5) {
      isZoomingRef.current = false;
      zoomperValue = "1";
      setZoomClassFull("");
    } else if (zoomValue == 6) {
      zoomperValue = "1.25";
      setZoomClassFull("");
    } else if (zoomValue == 7 || zoomValue == 8) {
      zoomperValue = "1.5";
    } else {
      setZoomClassFull("");
    }

    let pageInfo = document.getElementById("page");

    let pageOrignalWIdth = orignalPageWidth;
    let pageOrignalHeight = orignalPageHeight;

    let divImgWidth = Math.round(
      parseInt(pageOrignalWIdth) * parseFloat(zoomperValue)
    );
    let divImgHeight = Math.round(
      parseInt(pageOrignalHeight) * parseFloat(zoomperValue)
    );

    console.log("Width:" + divImgWidth);
    console.log("Height:" + divImgHeight);

    setpageWidthValue(divImgWidth);
    setpageWidthLeftValue((orignalMainPageWidth - divImgWidth) / 2);
    setpageHeightValue(divImgHeight);
    setExcelZoomScale(parseFloat(zoomperValue) || 1);
    setZoomValue(tempZoomValue);
    //setZoomClass(" r-transform" + tempZoomValue);
    setZoomClassHeight("rpdf-height" + tempZoomValue);
    console.log("Zoom in value", tempZoomValue);
    setZoomText(zoomOptions[tempZoomValue - 1]);
  };

  const requestServerPrintPdf = async () => {
    const rpdPrint = {
      DocumentId: documentId,
      RecpientId: tempRecipientId,
      DocumentLevelRestriction: documentLevelRestriction,
      ChkPageLevelRestriction: localPageLevelRestriction,
      PageLevelRestrictionData: documentLevelRestrictionDetails,
      EmailAddress: loginEmailAddress,
      OpenRecordId: openId,
      IsProceed: false
    };
    const url = `${process.env.REACT_APP_API}/docs/PrintData`;

    try {
      const raw = await fetch(url, {
        method: "POST",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(rpdPrint),
      });

      if (raw.status == 502) {
        window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
        return false;
      }

      const response = await raw.json();
      if (response?.authenticated) {
        if (response.message != null && response.message == "declined") {
          localStorage.setItem("DeclinedVar_" + documentId, "false");
        } else {
          localStorage.setItem("DeclinedVar_" + documentId, "true");
        }
        const redirectPath = new URL(response.redirectUrl).pathname;
        navigate(redirectPath, {
          replace: true,
          state: {
            translationsMap: { ...translationsMap }
          }
        });
        return true;
      }

      if (response && response.message) {
        setPrintLimitMessage(response.message);
        setShowPrintLimitPopup(true);
        setOpenLoader(false);
        setIsLeftOutMessage(false);
        return true;
      }

      if (response && response.data && response.leftOutMessage) {
        setPrintLimitMessage(response.leftOutMessage);
        setShowPrintLimitPopup(true);
        setOpenLoader(false);
        setPrintData(response.data);
        setIsLeftOutMessage(true);
        return true;
      }

      if (response?.data) {
        showPrintScreen(response.data);
        return true;
      }
      return false;
    } catch (error) {
      console.log("Document print read error.");
      setOpenLoader(false);
      return false;
    }
  };

  // RShield: one suppression session per print action.
  //
  // While the app's print dialog is up, a focus loss must not be counted and
  // the "window not in focus" pause must not show. The full screen requirement
  // is NOT waived (see useDocumentProtection): the browser leaves full screen
  // when the print dialog opens, so the view blurs behind "Enter Full Screen".
  //
  // The session has to end reliably. The PDF is printed from a hidden iframe
  // that takes focus, so the main window's `focus` / `afterprint` often never
  // fire - which previously left protection suppressed for up to 2 minutes.
  // It now also ends on the iframe's `afterprint`, and on the first pointer /
  // key input on the page once print() has been called (the print dialog is
  // modal, so the page gets no input until it is closed).
  const noopPrintSession = useMemo(
    () => ({ expectPrint: () => {}, armAfterPrint: () => {}, finish: () => {}, pending: () => false }),
    []
  );
  const printSessionRef = useRef(null);
  const suppressProtectionForPrint = useCallback(() => {
    if (!documentProtection.active) return noopPrintSession;
    // handlePrint and showPrintScreen both call this - reuse the live session.
    if (printSessionRef.current) return printSessionRef.current;

    documentProtection.beginInAppAction("Print");
    document.body.classList.add("dp-app-printing");

    let settled = false;
    let printPending = false;
    const watchedWindows = [];
    const inputEvents = ["pointerdown", "pointermove", "keydown", "wheel", "touchstart"];
    let armTimer = null;

    const onInput = () => finish();
    const onRefocus = () => setTimeout(finish, 300);

    const finish = () => {
      if (settled) return;
      settled = true;
      clearTimeout(timer);
      clearTimeout(armTimer);
      window.removeEventListener("focus", onRefocus);
      watchedWindows.forEach((w) => {
        try {
          w.removeEventListener("afterprint", finish);
        } catch (err) {
          /* iframe may already be gone */
        }
      });
      inputEvents.forEach((ev) => document.removeEventListener(ev, onInput, true));
      document.body.classList.remove("dp-app-printing");
      if (printSessionRef.current === session) printSessionRef.current = null;
      // The print iframe took focus; hand it back to the page so the
      // "window not in focus" state clears without an extra click.
      try {
        window.focus();
      } catch (err) {
        /* ignore */
      }
      documentProtection.endInAppAction();
    };

    const watchAfterPrint = (w) => {
      if (!w || watchedWindows.indexOf(w) > -1) return;
      try {
        w.addEventListener("afterprint", finish, { once: true });
        watchedWindows.push(w);
      } catch (err) {
        /* cross-origin / detached window - rely on the other signals */
      }
    };

    const session = {
      /** A print dialog is about to be opened (async - e.g. iframe load). */
      expectPrint: () => {
        printPending = true;
      },
      /** Call right after print() has been invoked on `printWindow`. */
      armAfterPrint: (printWindow) => {
        printPending = true;
        watchAfterPrint(printWindow);
        // Short delay so input that was already in flight when print() was
        // called does not end the session before the dialog is up.
        clearTimeout(armTimer);
        armTimer = setTimeout(() => {
          if (settled) return;
          inputEvents.forEach((ev) => document.addEventListener(ev, onInput, true));
        }, 1000);
      },
      finish,
      pending: () => printPending,
    };

    watchAfterPrint(window);
    window.addEventListener("focus", onRefocus, { once: true });
    const timer = setTimeout(finish, 120000);

    printSessionRef.current = session;
    return session;
  }, [documentProtection, noopPrintSession]);

  const handlePrint = async (e) => {
    e?.preventDefault?.();
    resetTimer();
    const printSession = suppressProtectionForPrint();
    setOpenLoader(true);
    setLoadingmessage(2);

    // For Excel files, skip the server PDF API and use client-side printing
    // from the original Excel file data for the best fidelity.
    if (isExcelFile) {
      setOpenLoader(false);

      // Primary: re-parse original binary data → XLSX.utils.sheet_to_html() per sheet
      if (excelViewerRef.current && typeof excelViewerRef.current.printFromSource === "function") {
        excelViewerRef.current.printFromSource();
        // usePrint opens its own iframe (print() after ~400ms); its window is
        // not exposed, so the session ends on the page input / focus signals.
        printSession.armAfterPrint(null);
        return;
      }

      // Fallback: DOM-clone of the rendered viewer table
      if (excelViewerRef.current && typeof excelViewerRef.current.printAsPdf === "function") {
        excelViewerRef.current.printAsPdf();
        printSession.armAfterPrint(null);
        return;
      }

      // Last resort: CSS isolation + window.print()
      const styleId = "excel-print-isolation";
      let styleEl = document.getElementById(styleId);
      if (!styleEl) {
        styleEl = document.createElement("style");
        styleEl.id = styleId;
        styleEl.textContent = [
          "@media print {",
          "  body * { visibility: hidden !important; }",
          "  #imgContainer,",
          "  #imgContainer * { visibility: visible !important; }",
          "  #imgContainer {",
          "    position: absolute !important;",
          "    left: 0 !important; top: 0 !important;",
          "    width: 100% !important; margin: 0 !important; padding: 0 !important;",
          "  }",
          "  .simple-excel-viewer { overflow: visible !important; height: auto !important; }",
          "  .simple-excel-grid-wrapper { overflow: visible !important; }",
          "  .simple-excel-formula-bar, .simple-excel-sheetbar,",
          "  .filter-excel-btn, .col-resize-handle, .row-resize-handle { display: none !important; }",
          "}",
        ].join("\n");
        document.head.appendChild(styleEl);
      }
      window.print();
      printSession.armAfterPrint(window);
      const cleanup = () => {
        const el = document.getElementById(styleId);
        if (el) el.remove();
        window.removeEventListener("afterprint", cleanup);
      };
      window.addEventListener("afterprint", cleanup);
      return;
    }

    const isServerPrinted = await requestServerPrintPdf();
    // No print dialog was opened (print limit popup, redirect, error): end
    // the suppression now instead of leaving protection paused. The limit
    // popup's Proceed button starts its own session via showPrintScreen.
    if (!printSession.pending()) printSession.finish();
    if (isServerPrinted) return;

    setOpenLoader(false);
  };

  function showPrintScreen(printData) {
    const printSession = suppressProtectionForPrint();
    try {
      printSession.expectPrint();
      let byteCharacters = atob(printData);
      let byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      let byteArray = new Uint8Array(byteNumbers);
      let file = new Blob([byteArray], { type: "application/pdf" });
      let fileURL = URL.createObjectURL(file);

      let divId = document.getElementById("dvframe");
      const iframe = document.createElement("iframe");
      iframe.style.display = "none";
      iframe.src = fileURL;

      iframe.onload = () => {
        setOpenLoader(false);
        try {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
          printSession.armAfterPrint(iframe.contentWindow);
        } catch (printErr) {
          console.log("Error triggering print from iframe", printErr);
          printSession.finish();
        }
      };
      const fallbackTimer = setTimeout(() => {
        if (iframe.contentWindow) {
          setOpenLoader(false);
          try {
            iframe.contentWindow.focus();
            iframe.contentWindow.print();
            printSession.armAfterPrint(iframe.contentWindow);
          } catch (printErr) {
            console.log("Fallback print error", printErr);
            printSession.finish();
          }
        }
      }, 5000);

      iframe.addEventListener("load", () => clearTimeout(fallbackTimer), { once: true });

      divId.appendChild(iframe);
    }
    catch (ex) {
      console.log("Error in showing print screen", ex);
      setOpenLoader(false);
      printSession.finish();
    }
  }

  const toAddressChange = async (e) => {
    setAllowResponsesTo(e.target.value);
    //this.setState({selectValue:e.target.value});
  };
  const modelPopupToClose = () => {
    setMpdelOpen(false);
  };
  const modelPopupYouDontHaveAccessClose = () => {
    setPageRestrictedFlag(false);
    setPageRestrictedCount(0);
  };
  const modelPopupNoUnitsClose = () => {
    setIsNoUnitsPopup(false);
  };
  const pageviewPopupToClose = () => {
    setPageviewModelOpen(false);
  };
  const sendToemailClose = (e) => {
    resetTimer();
    setSendEmailButton("");
    let defaultvalue = defaultToAddress;
    setAllowResponsesTo(defaultvalue);
    setreplySubject(defaultSubject);
    setreplymessage("");
  };
  const sendToEmail = async (e) => {
    try {
      resetTimer();
      setSendEmailButton("true");
      setOpenLoader(true);
      setLoadingmessage(1);

      let url = `${process.env.REACT_APP_API}/docs/sendtoemail`;

      if (replySubject !== "" && replySubject.length > 255) {
        setModelMessage(translationsMap.API_SubjectMsg.replace("{0}", "255"));
        setSendEmailButton("");
        setMpdelOpen(true);
        return;
      } else if (replymessage !== "" && replymessage.length > 1024) {
        setModelMessage(translationsMap.Reader_EmailBodyMsg.replace("{0}", "1024"));
        setSendEmailButton("");
        setMpdelOpen(true);
        return;
      } else if (!replySubject) {
        setModelMessage(translationsMap.Reader_PleaseEnterSubject);
        setSendEmailButton("");
        setMpdelOpen(true);
        return;
      }

      let data = {
        DocumentId: documentId,
        ToAddress: allowResponsesTo,
        Subject: replySubject,
        Message: replymessage,
        FromAddress: loginEmailAddress,
        RecipientId: recipientId,
      };

      // 👇 FETCH CLEAN VERSION
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });

      if (response.status == 502) {
        window.location.href = `${process.env.REACT_APP_API_Maintenance}`;
        return;
      }

      const result = await response.json();

      console.log(result);

      if (result.authenticated) {
        setSendEmailButton("");
        clearTimerAndInterval();

        if (result.message === "declined") {
          localStorage.setItem("DeclinedVar_" + documentId, "false");
        } else {
          localStorage.setItem("DeclinedVar_" + documentId, "true");
        }

        const redirectPath = new URL(result.redirectUrl).pathname;

        navigate(redirectPath, {
          replace: true,
          state: {
            translationsMap: { ...translationsMap },
          },
        });
      } else {
        setSendEmailButton("");
        document.getElementById("closeReplytoOwner").click();
        setModelMessage(translationsMap.Reader_EmailSuccessfullySent);
        setMpdelOpen(true);

        setAllowResponsesTo(defaultToAddress);
        setreplySubject(defaultSubject);
        setreplymessage("");
      }

    } catch (error) {
      console.log("Document read error", error);
    } finally {
      setOpenLoader(false); // ALWAYS runs last
    }

  };
  const hidemenu = (event) => {
    setShow(false);

    // disablePageNum(1);
  };

  let ipAddress = "0";
  function handleVerifyEmail(event) {
    setPageEmails(prev => ({ ...prev, [currentpage]: event.target.value }));
  }

  const togglePassword = () => {
    if (PasscodeType === "password") {
      setPasscodeType("text");
      return;
    }
    setPasscodeType("password");
  };

  function isValidURL(urlString) {
    try {
      new URL(urlString);
      return true;
    } catch (error) {
      return false;
    }
  }
  function handlePasscode(event) {
    setPasscode(event.target.value.replace(/\s/g, ""));
  }

  async function GenerateLevelOnePasscode(isFromVerify = '') {
    try {
      const browserLanguage = localStorage.getItem("language") || "en-us";
      if (submittedRequestEmail && pageEmails[currentpage] !== submittedRequestEmail) pageEmails[currentpage] = submittedRequestEmail;
      const url = `${process.env.REACT_APP_API}/docs/code/${documentId}` + `?email=${encodeURIComponent(pageEmails[currentpage] || submittedRequestEmail)}` + `&securitylevel=1` + `&browserLanguage=${browserLanguage}` + `&currentPageNum=${encodeURIComponent(currentpage || "")}` + `&isFromL1VerifyCode=${(isFromVerify === true) ? true : false}`;
      const res = await fetch(url);
      console.log(res);
      const response = await res.json();
      console.log(response);
      // SUCCESS
      if (!response?.authenticated && isLevelOne && !response.errorMessage) {
        let status = "";
        if (response.statusMessage === "Declined") {
          status = "Declined";
          setSubmittedRequestEmail(submittedRequestEmail !== "" ? submittedRequestEmail : pageEmails[currentpage]);
          setPageStatus(status);
        } else if (response.statusMessage === "Approved") {
          status = "Approved";
          if (isFromVerify === true) setSubmittedRequestEmail(submittedRequestEmail !== "" ? submittedRequestEmail : pageEmails[currentpage]);
          setPageStatus(status);
          setisVerified(true);
          setShowRestrictedPopup(true);
          setPageLevelRestriction(true);
          return "Approved";
        } else if (response.statusMessage === "Pending") {
          status = "Pending";
          setSubmittedRequestEmail(submittedRequestEmail !== "" ? submittedRequestEmail : pageEmails[currentpage]);
          setPageStatus(status);
        }
        if (status !== "") { setPageRequestStatus(prev => ({ ...prev, [currentpage]: status })); }
        // if (status !== "") {
        //   const updatedStatuses = {};
        //   if (status === "Approved") {
        //     (response.approvedPages || []).forEach(page => { updatedStatuses[page] = "Approved"; });
        //   }
        //   else {
        //     (response.requestedPages || []).forEach(page => { updatedStatuses[page] = status; });
        //   }
        //   setPageRequestStatus(prev => ({ ...prev, ...updatedStatuses }));
        // }
      }
      else if (response && response.authenticated) {
        if (isFromVerify === true) {
          setMpdelOpen(true);
          setModelMessage(translationsMap.Reader_UserVerificationFailure);
        } else {
          console.log("Passcode generated successfully");
          handleRequestAccess(response);
        }
      }
      // ERROR MESSAGE
      else if (response && !response.authenticated && response.errorMessage != null) {
        setMpdelOpen(true);
        setModelMessage(response.errorMessage);
      }
      // Already registered
      else if (response) {
        setisVerified(true);
        setPasscode(response?.passcode);
      }
      // REDIRECT CASE
      else if (response && !response.authenticated && response.redirectUrl != null) {
        localStorage.setItem("FileName", response.fileName);
        localStorage.setItem("url", response.redirectUrl);
        localStorage.setItem("documentId", documentId);
        if (isValidURL(response.redirectUrl)) {
          const redirectPath = new URL(response.redirectUrl).pathname;
          navigate(redirectPath, { replace: true });
        } else {
          navigate(response.redirectUrl, { replace: true });
        }
      }
    } catch (error) {
      console.error("GenerateLevelOnePasscode Error", error);
    }
  }

  const verifyCode = async () => {
    const status = await GenerateLevelOnePasscode(true);
    if (status === "Approved") {
      console.warn("when verify/ called " + new Date());
      let browserName = getBrowserName();
      console.log(`${process.env.REACT_APP_API}`);
      if (pageEmails[currentpage] == '' || passcode == '') {
        setMpdelOpen(true);
        setModelMessage(translationsMap.Reader_UserVerificationFailure);
        return;
      }
      const url = `${process.env.REACT_APP_API}/docs/verify/${documentId}`;
      setLoadingmessage(1);
      // setOpenLoader(true);
      let result;
      const requestOptions = {
        mode: "cors",
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: pageEmails[currentpage],
          code: passcode,
          ip: ipAddress,
          userBrowser: browserName,
          isL1Authentication: true
        }),
      };
      fetch(url, requestOptions)
        .then((response) => response.json())
        .then((response) => {
          console.warn("when verify/ responded " + new Date());
          console.log(response);
          console.log(response.status);

          if (response && !response.authenticated) {
            setSubmittedRequestEmail("");
            setMpdelOpen(true);
            setModelMessage(translationsMap.Reader_UserVerificationFailure);
            // setOpenLoader(false);
          } else if (response && response.statusMessage === "Request Approved") {
            const approvedPagesResponse = response.approvedPages || [];
            setApprovedPages(approvedPagesResponse);
            setDocumentLevelRestrictionDetails(prevDetails => {
              if (!Array.isArray(prevDetails)) return prevDetails;
              return prevDetails.map(element => ({
                ...element,
                pages: Array.isArray(element.pages)
                  ? element.pages.filter(p => !approvedPagesResponse.includes(p))
                  : []
              }));
            });
            imgURLDataArray.current.map(item => {
              if (approvedPagesResponse.includes(item.pageNum + 1)) {
                item.pageLevelRestriction = false;
              }
            })
            console.log(documentLevelRestrictionDetails);
            const isPageApproved = response.approvedPages?.includes(currentpage);
            if (isPageApproved) {
              setisVerified(false);
              setShowRestrictedPopup(false);
              setPageLevelRestriction(false);
            }
          } else if (response && response.redirectUrl != null && response.redirectUrl != "") {
            localStorage.setItem("FileName", response.fileName);
            localStorage.setItem("url", response.redirectUrl);
            localStorage.setItem("documentId", documentId);
            localStorage.setItem("ContinentCode_" + documentId, response.continentCode);
            localStorage.setItem("RecipientEmail_" + documentId, response.recipientEmail);
            localStorage.setItem("RecipientIp_" + documentId, response.readerIp);
            localStorage.setItem("Network_" + documentId, response.network);
            localStorage.setItem("Location_" + documentId, response.location);
            localStorage.setItem("UserAgent_" + documentId, response.userAgent);
            if (response.message != null && response.message === "declined") {
              localStorage.setItem("DeclinedVar_" + documentId, "true");
            } else {
              localStorage.setItem("DeclinedVar_" + documentId, "false");
            }
            if (isValidURL(response.redirectUrl)) {
              const redirectPath = new URL(response.redirectUrl).pathname;
              navigate(redirectPath, {
                replace: true,
                state: {
                  translationsMap: { ...translationsMap }
                }
              });
            } else {
              navigate(response.redirectUrl, {
                replace: true,
                state: {
                  translationsMap: { ...translationsMap }
                }
              });
            }
          } else {
            // setOpenLoader(false);
            console.log(response.status);
          }
        }).catch((error) => { setOpenLoader(false); console.log(error); });
    }
  };
  const setStatusOfSubmittedRequestEmail = ({ email, pages }) => {
    setSubmittedRequestEmail(email);
    setPageRequestStatus((prev) => {
      const updated = { ...prev };
      pages.forEach((page) => { updated[page] = "Pending"; });
      return updated;
    });
  };

  return (
    <>
      {/* RShield - blocking overlay (full screen prompt / blur / revoked). */}
      <ProtectionOverlay {...documentProtection.overlayProps} />
      {/* RShield - print notice (dismiss with OK). */}
      <ProtectionOverlay
        visible={printNoticeOpen && !documentProtection.isRevoked}
        title={
          (translationsMap && translationsMap.Reader_PrintNoticeTitle) ||
          "Print Button Clicked"
        }
        message={
          (translationsMap &&
            translationsMap.Reader_PrintingDocumentIsNotPermitted) ||
          "Print button is clicked. Printing this protected document is not permitted."
        }
        actionLabel={(translationsMap && translationsMap.Reader_OK) || "OK"}
        onAction={() => setPrintNoticeOpen(false)}
      />
      {onlineStatus === false && (
        <div
          className="rpdFont modal"
          id="PagewModel"
          style={{
            display: "block",
            backgroundColor: "#54404061",
            zIndex: "9999999",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="mb3" style={{ textAlign: "center" }}>
                  <img
                    src={`data:image/png;base64,${noInternetImg}`}
                    className="h-100px"
                  />
                </div>

                <h5
                  className="text-center noInternetPadding res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {translationsMap.Reader_InternetConnectProblem +
                    " " +
                    translationsMap.Reader_ConnectivityReauthenticate}
                </h5>
              </div>
            </div>
          </div>
        </div>
      )}
      {/* <Translations documentId={documentId}></Translations> */}
      {openLoader ? (
        Loadingmessage == 1 ? (
          <div className="spinerAuth-text">
            <LoadingSpinner authenticatingMsg={translationsMap.Reader_SendingYourReply} newDesignFlag={false} />
          </div>
        ) : Loadingmessage == 2 ? (
          <div className="spinerAuth-text">
            <LoadingSpinner authenticatingMsg={translationsMap.Reader_LoadingPleaseWait} newDesignFlag={false} />
          </div>
        ) : (
          <div className="spinerAuth-text">
            <LoadingSpinner authenticatingMsg={translationsMap.Reader_LoadingPleaseWait} newDesignFlag={false} />
          </div>
        )
      ) : null}
      {/* alerts */}
      <Alert
        alertType={alertType}
        alertMsg={alertMsg}
        class="xlwe-save-alert"
        className="alerthist"
      ></Alert>
      {/* end */}
      {PageviewModelOpen === true && (
        <div
          className="rpdFont modal"
          id="PageviewModel"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <h5
                  className="text-center my-4 res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {translationsMap.Reader_NoUnitbalanceMessage}
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#040921",
                    }}
                    onClick={pageviewPopupToClose}
                  >
                    {Reader_OK}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <section>
        <header className="d-none" onContextMenu={(e) => e.preventDefault()}>
          <nav className="rpdFont navbar navbar-expand-md navbar-light fixed-top rpd-bg-them">
            <div className="container-fluid">
              <a className="navbar-brand p-0" href="#" onClick={(e) => e.preventDefault()}>
                <img src={RdocsWhite} alt="" height="45px"></img>
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarCollapse"
                aria-controls="navbarCollapse"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="material-icons"> menu </span>
              </button>
              <div className="collapse navbar-collapse" id="navbarCollapse">
                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                  <li className="nav-item">
                    <a
                      className="nav-link  p-md-0 font20 ms-4 d-h-font"
                      aria-current="page"
                      href="#"
                      onClick={(e) => e.preventDefault()}
                      style={{ color: "#ffffff", fontWeight: "500" }}
                    >
                      {translationsMap.Reader_DigitalRightsManagement}
                    </a>
                  </li>
                </ul>
                <form className="d-sm-none d-md-block">
                  <ul className="navbar-nav d-flex align-items-center res-w100 resalign-items-start me-auto mb-2 mb-md-0">
                    <li className="nav-item res-w100">
                      <a className="nav-link p-0" href="#" onClick={(e) => e.preventDefault()}>
                        <img
                          src={RpostPowered}
                          alt=""
                          className="h-52p"
                          id="hiddenclickimg"
                        />
                      </a>
                    </li>
                  </ul>
                </form>
              </div>
            </div>
          </nav>
        </header>

        {/* Index Header */}
        <header onContextMenu={(e) => e.preventDefault()}>
          <nav className="rpdFont navbar navbar-expand-md navbar-light fixed-top rpd-bg-them">
            <div className="container-fluid">
              <a
                className="navbar-brand p-0"
                href={
                  SessionpopuupDisable == 0
                    ? "https://rpostdocs.io/"
                    : undefined
                }
                target="_blank"
              >
                <img src={RdocsWhite} alt="" height="45px"></img>
              </a>

              <button
                //   onClick="imageClick()"
                className="navbar-toggler"
                type="button"
                onClick={() => setShow(!show)}
              >
                <span className="material-icons text-white"> menu </span>
              </button>
              <div
                className="collapse navbar-collapse"
                style={show ? { display: "block" } : { display: "none" }}
                id="navbarCollapse"
              >
                <ul className="navbar-nav me-auto mb-2 mb-md-0">
                  <li className="nav-item">
                    <a
                      className="rpdFont nav-link p-md-0 font20 ms-4 font-500"
                      aria-current="page"
                      style={{ color: "#ffffff" }}
                      onClick={(e) => hidemenu(show)}
                    >
                      {translationsMap.Reader_ProtectedDocumentViewer}
                    </a>
                  </li>
                </ul>
                <form className="d-sm-none d-md-block">
                  <ul className="navbar-nav d-flex align-items-center res-w100 resalign-items-start me-auto mb-2 mb-md-0">
                    <li className="nav-item res-w100">
                      <a
                        className="nav-link p-0"
                        href={
                          SessionpopuupDisable == 0
                            ? "https://rpost.com/"
                            : undefined
                        }
                        target="_blank"
                      >
                        <img
                          src={RpostPowered}
                          alt="Logo"
                          className="h-52p"
                          id="hiddenclickimg"
                        ></img>
                      </a>
                    </li>
                  </ul>
                </form>

                <form className="d-sm-block d-md-none parentscroll-menu">
                  <ul className="navbar-nav d-flex  res-w100 resalign-items-start me-auto mb-2 mb-md-0 scroll-menu">
                    {isVoting === true && (
                      <li className="nav-item dropdown res-w100 res-border">
                        <a
                          className="rpdFont nav-link dropdown-toggle active d-flex text-white"
                          data-bs-toggle="modal"
                          data-bs-target="#myModal2"
                          href="/#"
                          alt="Voting"
                          onClick={(e) => {
                            e.preventDefault();
                            hidemenu(show);
                          }}
                        >
                          <span
                            className={
                              (VotedValue === -1
                                ? "thumsMColor "
                                : VotedValue === 0
                                  ? "thumsDownColor "
                                  : "thumsUpColor ") + "material-icons text-white"
                            }
                          >
                            {" "}
                            {VotedValue === 0
                              ? "thumb_down_alt"
                              : "thumb_up_alt"}{" "}
                          </span>
                          <span className="rpdFont ms-3 d-sm-block d-md-none text-white">
                            {translationsMap.Reader_Voting}
                          </span>
                        </a>
                      </li>
                    )}
                    {isDistributionList === true && (
                      <li className="nav-item dropdown res-w100 res-border">
                        <a
                          className="nav-link d-flex active dropdown-toggle text-white"
                          data-bs-toggle="dropdown"
                          href="/#"
                          onClick={(e) => e.preventDefault()}
                        >
                          <span className="material-icons text-white">
                            {" "}
                            people{" "}
                          </span>
                          <span
                            className="rpdFont ms-3 d-sm-block d-md-none"
                            style={{ color: "#ffffff" }}
                          >
                            {translationsMap.Reader_DistributionList}
                          </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box xerox-h300"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          <li>
                            <p className="rpdFont note mb-0 dropdown-item text-white">
                              {translationsMap.Reader_UsersList}
                            </p>
                          </li>
                          {userlist.map((item, idex) => (
                            <li>
                              <p
                                className="dropdown-item mb-0 d-flex align-items-start rpdFont text-white"
                                href="/#"
                              >
                                {item.email}
                                {item.vote === 1 && (
                                  <span
                                    className="material-icons ms-2 text-white"
                                    style={{ color: "rgb(58, 177, 109)" }}
                                  >
                                    thumb_up_alt
                                  </span>
                                )}
                                {item.vote === 0 && (
                                  <span
                                    className="material-icons ms-2 text-white"
                                    style={{ color: "#c3272e" }}
                                  >
                                    thumb_down_alt
                                  </span>
                                )}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                    {isSideNote && (
                      <li className="dropdown nav-item res-w100 res-border">
                        <a
                          className="nav-link d-flex active dropdown-toggle text-white"
                          data-bs-toggle="dropdown"
                          onClick={handleSideNoteClick}
                          href="/#"
                        >
                          <span className="material-icons text-white">
                            {" "}
                            chat{" "}
                          </span>
                          {isSideNoteOpened == false && (
                            <span className="sidenote-unread-dot"></span>
                          )}
                          <span
                            className="rpdFont ms-3 d-sm-block d-md-none"
                            style={{ color: "#fff" }}
                          >
                            {translationsMap.Reader_SideNote}
                            <super className="superfont-10 text-white">®</super>
                          </span>
                        </a>

                        <ul
                          className="rpdFont dropdown-menu dropdown-menu-end arrow_box1"
                          style={{ background: "#9e9e9e3d" }}
                        >
                          <li>
                            <div className="d-flex flex-wrap">
                              <p className="rpdFont note dropdown-p mb-0 d-flex text-white">
                                <label> {translationsMap.Reader_NoteFrom}&nbsp;</label>

                                <label className="them-color mt-0 mb-0 font-500 text-white">
                                  {senderEmailAddress}
                                </label>
                              </p>
                            </div>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <p className="rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 font-16">
                              {docNote}
                            </p>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isallowResponsesTo && (
                      <li className="nav-item res-w100 res-border">
                        <a
                          className="rpdFont text-white nav-link d-flex active"
                          href="/#"
                          data-bs-toggle="modal"
                          data-bs-target="#replyToOwnerModel"
                          onClick={(e) => {
                            e.preventDefault();
                            hidemenu(show);
                          }}
                        >
                          <span className="material-icons text-white">
                            {" "}
                            drafts{" "}
                          </span>
                          <span className="rpdFont text-white ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_ReplyToDocument}
                          </span>
                        </a>
                      </li>
                    )}
                    {isPrint && !isExcelFile && (
                      <li className="nav-item res-w100 res-border">
                        <a
                          className={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages ? "rpdFont text-white nav-link d-flex active disabledPrint" : "rpdFont text-white nav-link d-flex active"}
                          onClick={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages ? null : handlePrint}
                          style={{ cursor: "pointer" }}
                        >
                          <span className="material-icons text-white">
                            {" "}
                            print{" "}
                          </span>
                          <span className="ms-3 d-sm-block d-md-none text-white">
                            {translationsMap.Reader_Print}
                          </span>
                        </a>
                      </li>
                    )}
                    <li className="rpdFont text-white dropdown nav-item res-w100 res-border">
                      <a
                        className="nav-link d-flex align-items-center active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        style={{ cursor: "pointer" }}
                        href={void 0}
                      >
                        <span className="material-icons text-white">
                          {" "}
                          info{" "}
                        </span>
                        <span className="rpdFont text-white ms-3 d-sm-block d-md-none">
                          More Information
                        </span>
                      </a>

                      <ul
                        className="rpdFont text-white dropdown-menu dropdown-menu-end arrow_box1"
                        style={{ background: "#9e9e9e3d" }}
                      >
                        <li>
                          <div className="d-flex flex-wrap">
                            <p className="RobotoFont note xerox-p d-flex dropdown-p mb-0">
                              <label
                                className="rpdFont text-white mt-0 mb-0"
                                style={{
                                  fontWeight: "500",
                                  color: "#fff",
                                }}
                              >
                                {translationsMap.Reader_ID}{" "}{documentId}
                              </label>
                            </p>
                          </div>
                        </li>
                        {/* <li>
                            <hr className="dropdown-divider" />
                          </li> */}
                        {
                          <TimerDisplay
                            reader_viewTime={Reader_viewTime}
                            class={
                              "rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                            }
                            styles={'fontSize: "16px",color: "#fff"'}
                          ></TimerDisplay>
                          // <li>
                          //   <p
                          //     className="rpdFont text-white dropdown-p d-flex flex-wrap text-justify mt-0 pt-0 mb-0"
                          //     style={{fontSize: "16px",color: "#fff"}}
                          //   >
                          //     {Reader_viewTime}
                          //     {" (hh:mm:ss)"}: {convertToHHMMSS(viewDocTime)}
                          //     {/* {viewDocTime === 1 ? "Min" : "Mins"} */}
                          //   </p>
                          // </li>
                        }
                      </ul>
                    </li>
                    <li className="nav-item res-w100 dropdown">
                      <a
                        className="nav-link text-white d-flex active dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="/#"
                        onClick={(e) => e.preventDefault()}
                      >
                        <span className="material-icons text-white">
                          {" "}
                          zoom_out_map{" "}
                        </span>
                        <span className="ms-3 d-sm-block d-md-none text-white">
                          {translationsMap.Reader_Zoom}
                        </span>
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end arrow_box"
                        style={{
                          background: "#9e9e9e3d",
                          maxHeight: "200px",
                          overflow: "auto",
                        }}
                      >
                        <li>
                          <button
                            type="button"
                            className="dropdown-item rpdFont text-white"
                            value={1}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            {translationsMap.Reader_ActualSize}
                          </button>
                        </li>
                        {!isExcelFile && (
                          <li>
                            <button
                              type="button"
                              className="rpdFont dropdown-item text-white"
                              value={2}
                              onClick={(e) =>
                                handleMobileZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FitPage"
                                )
                              }
                            >
                              {translationsMap.Reader_FitPage}
                            </button>
                          </li>
                        )}
                        {!isExcelFile && (
                          <li>
                            <button
                              type="button"
                              className="rpdFont dropdown-item text-white"
                              value={3}
                              onClick={(e) =>
                                handleMobileZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FullWidth"
                                )
                              }
                            >
                              {translationsMap.Reader_FullWidth}
                            </button>
                          </li>
                        )}
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={4}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "50%", "0.5")
                            }
                          >
                            50%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={5}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "75%", "0.75")
                            }
                          >
                            75%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={6}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "100%", "1")
                            }
                          >
                            100%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={7}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "125%", "1.25")
                            }
                          >
                            125%
                          </button>
                        </li>
                        <li>
                          <button
                            type="button"
                            className="rpdFont dropdown-item text-white"
                            value={8}
                            onClick={(e) =>
                              handleMobileZoomDropdown(e, "150%", "1.5")
                            }
                          >
                            150%
                          </button>
                        </li>
                      </ul>
                    </li>
                    {documentLevelRestriction && (
                      <li className="rpdFont dropdown nav-item">
                        <div
                          className="form-check checkbox-theme justify-content-center"
                          style={{ textAlign: "center", paddingTop: "0.3rem", paddingLeft: "0px", marginLeft: "-2px" }}
                        >
                          <input
                            className="chkAllowReaders"
                            type="checkbox"
                            value={localPageLevelRestriction}
                            checked={localPageLevelRestriction}

                            id="robot"
                            onChange={(e) => { handleChkChange(e) }}
                          />
                          <label className="form-check-label" htmlFor="rememberMe" style={{ paddingLeft: ".7rem", verticalAlign: "text-bottom" }}>
                            {translationsMap.Reader_AllowedPagesOnly}
                          </label>
                        </div>
                      </li>
                    )}
                    {/* RShield - capture detection warning, mobile menu. */}
                    <CaptureWarning
                      {...documentProtection.captureWarningProps}
                      label={translationsMap.Reader_RShieldCaptureWarningLabel}
                      variant="mobile"
                    />
                  </ul>
                </form>
              </div>
            </div>
          </nav>
        </header>
      </section>
      <main
        className={isExcelFile ? "rpdFont flex-shrink-0 min-vh-87" : (pageLevelRestriction ? "rpdFont flex-shrink-0 min-vh-94" : "rpdFont flex-shrink-0 min-vh-95")}
        style={{
          background: "#9a9a9a",
          position: "relative",
        }}
        onContextMenu={(e) => {
          // Allow right-click inside the OnlyOffice excel viewer so its context menu works
          //if (isExcelFile) return;
          e.preventDefault();
        }}
        id="mainPageView"
        onClick={(e) => hidemenu(show)}
      >
        <div
          className="container-fluid r-fixed-div"
          style={{ background: "#f3f3f3" }}
        >
          <div className="rpdFont row justify-content-center resmx-1 d-h-font">
            <div className="col-12 col-md-12 col-lg-12 col-xl-8">
              <div
                className="d-flex align-items-center justify-content-between resjustify-center top-n-1"
                id="iconsMenu"
              >
                <div
                  className="btn-toolbar d-sm-none d-md-block"
                  role="toolbar"
                  aria-label="Toolbar with button groups"
                >
                  <div
                    className="btn-group rpd-btngroup"
                    role="group"
                    aria-label="First group"
                  >
                    <button
                      type="button"
                      className=" btn btn-outline-secondary rpd-btncolor"
                      // className={ zoomClassDisabled != "" ? " btn btn-outline-secondary rpd-btncolor " + zoomClassDisabled : " btn btn-outline-secondary rpd-btncolor" }
                      onClick={(e) => handleZoomOut(e)}
                      disabled={pageLevelRestriction}
                    >
                      <span className="material-icons"> zoom_out </span>
                    </button>
                    <button
                      type="button"
                      className="rpdFont btn btn-outline-secondary rpd-btncolor customeborder  mn-wd-55"
                      disabled={pageLevelRestriction}
                    >
                      {zoomText}
                    </button>
                    <button
                      type="button"
                      className="btn btn-outline-secondary  rpd-btncolor customeborder"
                      onClick={(e) => handleZoomIn(e)}
                      disabled={pageLevelRestriction}
                    >
                      <span className="material-icons"> zoom_in </span>
                    </button>
                    <div className="btn-group">
                      <button
                        type="button"
                        className="rpdFont btn btn-outline-secondary rpd-btncolor dropdown-toggle customeborder bg-black"
                        data-bs-toggle="dropdown"
                        disabled={pageLevelRestriction}
                      >
                        <span className="material-icons"> expand_more </span>
                      </button>
                      <ul className="dropdown-menu rpddropdown">
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={1}
                            onClick={(e) => handleZoomDropdown(e, "100%", "1")}
                          >
                            {translationsMap.Reader_ActualSize}
                          </button>
                        </li>
                        {!isExcelFile && (
                          <li>
                            <button
                              className="rpdFont dropdown-item"
                              style={{ color: "#040921" }}
                              value={2}
                              onClick={(e) =>
                                handleZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FitPage"
                                )
                              }
                            >
                              {translationsMap.Reader_FitPage}
                            </button>
                          </li>
                        )}
                        {!isExcelFile && (
                          <li>
                            <button
                              className="rpdFont dropdown-item"
                              style={{ color: "#040921" }}
                              value={3}
                              onClick={(e) =>
                                handleZoomDropdown(
                                  e,
                                  zoomPercentage + "%",
                                  "FullWidth"
                                )
                              }
                            >
                              {translationsMap.Reader_FullWidth}
                            </button>
                          </li>
                        )}
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={4}
                            onClick={(e) => handleZoomDropdown(e, "50%", "0.5")}
                          >
                            50%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={5}
                            onClick={(e) =>
                              handleZoomDropdown(e, "75%", "0.75")
                            }
                          >
                            75%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={6}
                            onClick={(e) => handleZoomDropdown(e, "100%", "1")}
                          >
                            100%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={7}
                            onClick={(e) =>
                              handleZoomDropdown(e, "125%", "1.25")
                            }
                          >
                            125%
                          </button>
                        </li>
                        <li>
                          <button
                            className="rpdFont dropdown-item"
                            style={{ color: "#040921" }}
                            value={8}
                            onClick={(e) =>
                              handleZoomDropdown(e, "150%", "1.5")
                            }
                          >
                            150%
                          </button>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div className="rpd-btngroup">
                  <div
                    className="btn-toolbar d-flex align-items-center"
                    role="toolbar"
                    aria-label="Toolbar with button groups"
                  >
                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                      style={{ backgroundColor: "#040921" }}
                    >
                      <button
                        type="button"
                        id="btnPrevMin"
                        className={
                          (currentpage === 1
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary btn-page-navi rpd-btn first"
                        }
                        style={{ backgroundColor: "#040921" }}
                        onClick={handlePreviousMinWrap}
                      >
                        <span className="material-icons text-white  top-n2">
                          {" "}
                          first_page{" "}
                        </span>
                      </button>
                    </div>
                    <div
                      className="btn-group ms-1"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        type="button"
                        id="btnPrev"
                        className={
                          (currentpage === 1
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary lborder rpd-btn rpd-btn2"
                        }
                        onClick={handlePreviousChangeWrapper}
                      >
                        <span className="material-icons"> chevron_left </span>
                      </button>
                    </div>

                    <div className="rpdFont d-flex align-items-center justify-content-center">
                      <div className="d-flex align-items-center m-auto justify-content-center ms-2">
                        <input
                          type="text"
                          ref={totalPagesRef}
                          inputMode="numeric"
                          pattern="[0-9]*"
                          className={
                            (disablePageNavigationButtons == true
                              ? " disabled "
                              : "") + "form-control text-box"
                          }
                          value={currentTempPage}
                          onChange={(e) =>
                            handlePageNumChange(e.target.value)
                          }
                          onBlur={(e) => handleBlurPageNumChangeWrapper()}
                          onKeyDown={handleKeyDownPageNumChange}
                        />
                      </div>

                      <p
                        className="ms-2 me-2 mb-0 font17"
                        style={{ color: "black" }}
                      >
                        / {totalPages}
                      </p>
                    </div>

                    <div
                      className="btn-group"
                      role="group"
                      aria-label="First group"
                    >
                      <button
                        type="button"
                        id="btnNxt"
                        className={
                          (currentpage === totalPages
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary rpd-btn2 rborder rpd-btn"
                        }
                        disabled={disablePageNavigationButtons || currentpage === totalPages}
                        onClick={handleNextChangeWrapper}
                      >
                        <span className="material-icons"> navigate_next </span>
                      </button>
                    </div>
                    <div
                      className="btn-group ms-1"
                      role="group"
                      aria-label="First group"
                      style={{ backgroundColor: "#040921" }}
                    >
                      <button
                        type="button"
                        id="btnNxtMax"
                        className={
                          (currentpage === totalPages
                            ? "disabled "
                            : disablePageNavigationButtons == true
                              ? " disabled "
                              : "") +
                          "btn btn-outline-secondary rpd-btn btn-page-navi last"
                        }
                        style={{ backgroundColor: "#040921" }}
                        onClick={handleNextMaxWrap}
                      >
                        <span className="material-icons text-white  top-n2">
                          {" "}
                          last_page{" "}
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="d-flex align-items-center d-sm-none d-md-block">
                  <ul className="no-bullets">
                    {isVoting === true && (
                      <li className="nav-item dropdown res-w100">
                        <a
                          className="r-nav-link dropdown-toggle"
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          data-bs-toggle="modal"
                          data-bs-target="#myModal2"
                          data-toggle="tooltip"
                          title={translationsMap.Reader_ClickToVote}
                        >
                          <span
                            className={
                              (VotedValue === -1
                                ? "thumsColor1 "
                                : VotedValue === 0
                                  ? "thumsDownColor "
                                  : "thumsUpColor ") + "material-icons"
                            }
                          >
                            {" "}
                            {VotedValue === 0
                              ? "thumb_down_alt"
                              : "thumb_up_alt"}{" "}
                          </span>
                        </a>

                        <ul className="rpdFont dropdown-menu dropdown-menu-end arrow_box">
                          <li>
                            <p className="note dropdown-item mb-2">
                              {translationsMap.Reader_Voting}:
                            </p>
                          </li>
                          <li>
                            <a
                              className="dropdown-item border border-bottom-1 d-flex align-items-center"
                              href="#"
                              onClick={(e) => e.preventDefault()}
                            >
                              <span
                                className="material-icons me-2"
                                style={{
                                  color: "rgb(58, 177, 109)",
                                  fontSize: "20px",
                                }}
                              >
                                thumb_up
                              </span>
                              {translationsMap.Reader_Like}
                            </a>
                          </li>
                          <li>
                            <a
                              className="dropdown-item border d-flex align-items-center border-bottom-0"
                              href="#"
                              onClick={(e) => e.preventDefault()}
                            >
                              <span
                                className="material-icons me-2"
                                style={{ color: "#c3272e", fontSize: "20px" }}
                              >
                                thumb_down
                              </span>
                              {translationsMap.Reader_Dislike}
                            </a>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isDistributionList === true && (
                      <li className="rpdFont nav-item dropdown res-w100">
                        <a
                          className="rpdFont r-nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="#"
                          onClick={(e) => e.preventDefault()}
                          data-toggle="tooltip"
                          title={translationsMap.Reader_ViewDistributionList}
                        >
                          <span className="material-icons"> people </span>
                        </a>

                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box2"
                          style={{
                            position: "absolute",
                            inset: "0px auto auto 0px",
                            margin: "0px",
                            transform: "translate(-211px, 45px)",
                            padding: "0px",
                            maxHeight: "350px",
                            overflow: "auto",
                            whiteSpace: "initial",
                            minWidth: "300px",
                            maxWidth: "350px",
                          }}
                        >
                          <li>
                            <p
                              className="rpdFont note mb-0 dropdown-item"
                              style={{ color: "rgb(4, 9, 33)" }}
                            >
                              {translationsMap.Reader_DistributionList}:
                            </p>
                          </li>
                          {userlist.map((item, idex) => (
                            <li>
                              <p
                                className="rpdFont dropdown-item border border-bottom-1 d-flex align-items-start wordwrap"
                                style={{ marginBottom: "0px" }}
                              >
                                {(item.firstName || item.lastName) && (
                                  <span className="spanAlign">
                                    {item.firstName} {item.lastName}
                                    <br />
                                    {`<${item.email}>`}
                                  </span>
                                )}
                                {!item.firstName && !item.lastName && (
                                  <span className="spanAlign">
                                    {item.email}
                                  </span>
                                )}
                                {item.vote === 1 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "rgb(58, 177, 109)" }}
                                  >
                                    thumb_up_alt
                                  </span>
                                )}
                                {item.vote === 0 && (
                                  <span
                                    className="material-icons ms-2"
                                    style={{ color: "#c3272e" }}
                                  >
                                    thumb_down_alt
                                  </span>
                                )}
                              </p>
                            </li>
                          ))}
                        </ul>
                      </li>
                    )}
                    {isSideNote && (
                      <li className="rpdFont dropdown nav-item res-w100">
                        <a
                          className="rpdFont r-nav-link dropdown-toggle"
                          data-bs-toggle="dropdown"
                          href="/#"
                          data-toggle="tooltip"
                          title={translationsMap.Reader_ViewSideNote}
                          onClick={handleSideNoteClick}
                        >
                          <span className="sidenote-icon-wrapper">
                            <span className="material-icons"> chat </span>
                            {isSideNoteOpened == false && (
                              <span className="sidenote-unread-dot"></span>
                            )}
                          </span>
                        </a>


                        <ul
                          className="dropdown-menu dropdown-menu-end arrow_box2"
                          style={{ minWidth: "22rem", maxWidth: "300px" }}
                        >
                          <li>
                            <div className="rpdFont d-flex flex-wrap">
                              <p className="rpdFont note dropdown-p mb-0 d-flex">
                                <label style={{ color: "rgb(4, 9, 33)" }}>
                                  {" "}
                                  {translationsMap.Reader_SideNote}
                                  <super className="superfont-10">®</super>
                                  :&nbsp;
                                </label>

                                <label
                                  className="rpdFont them-color mt-0 mb-0 wordwrap"
                                  style={{ fontWeight: "500" }}
                                >
                                  {senderEmailAddress}
                                </label>
                              </p>
                            </div>
                          </li>
                          <li>
                            <hr className="dropdown-divider" />
                          </li>
                          <li>
                            <p
                              className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                              style={{
                                fontSize: "16px",
                                maxHeight: "350px",
                                overflow: "auto",
                                whiteSpace: "initial",
                              }}
                            >
                              {docNote}
                            </p>
                          </li>
                        </ul>
                      </li>
                    )}
                    {isallowResponsesTo && (
                      <li className="rpdFont nav-item res-w100">
                        <a
                          className="rpdFont r-nav-link"
                          style={{ cursor: "pointer" }}
                          data-bs-toggle="modal"
                          data-bs-target="#replyToOwnerModel"
                          data-toggle="tooltip"
                          title={translationsMap.Reader_ReplyToDocument}
                        >
                          <span className="material-icons"> drafts </span>
                          <span className="ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_ReplyToDocument}
                          </span>
                        </a>
                      </li>
                    )}
                    {isPrint && !isExcelFile && (
                      <li className={"rpdFont rpdFont nav-item res-w100"}>
                        <a
                          className={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages ? "rpdFont r-nav-link disabledPrint" : "rpdFont r-nav-link dis"}
                          style={{ cursor: "pointer" }}
                          data-bs-toggle="modal"
                          onClick={documentLevelRestrictionDetails?.[0]?.pages?.length === totalPages ? null : handlePrint}
                          data-toggle="tooltip"
                          title={translationsMap.Reader_ClickToPrint}
                        >
                          <span className="material-icons"> print </span>
                          <span className="ms-3 d-sm-block d-md-none">
                            {translationsMap.Reader_Print}
                          </span>
                        </a>
                      </li>
                    )}
                    <li className="rpdFont dropdown nav-item res-w100">
                      <a
                        className="rpdFont r-nav-link dropdown-toggle"
                        data-bs-toggle="dropdown"
                        href="/#"
                        onClick={(e) => e.preventDefault()}
                        data-toggle="tooltip"
                      // title="Document info"
                      >
                        <span
                          className="material-icons"
                          style={{ color: "#040921" }}
                        >
                          {" "}
                          info{" "}
                        </span>
                      </a>
                      <ul
                        className="dropdown-menu dropdown-menu-end arrow_box2"
                        style={{
                          minWidth: "22rem",
                          maxWidth: "200px",
                          maxHeight: "110px",
                        }}
                      >
                        <li>
                          <div className="rpdFont d-flex flex-wrap justify-content-end">
                            <p
                              className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                              style={{
                                fontSize: "16px",
                                maxHeight: "350px",
                                overflow: "auto",
                                whiteSpace: "initial",
                                color: "black !important",
                                display: "none",
                              }}
                            >
                              {translationsMap.Reader_ID}
                              <span style={{ display: "block" }}>
                                &nbsp;{documentId}
                              </span>
                            </p>
                          </div>
                        </li>
                        {
                          <TimerDisplay
                            reader_viewTime={translationsMap.RPostReader_viewTime}
                            class={
                              "rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                            }
                            styles={
                              'fontSize: "16px",maxHeight: "350px",overflow: "auto",whiteSpace: "initial",display: "none"'
                            }
                          ></TimerDisplay>
                          // <li>
                          //   <p
                          //     className="rpdFont dropdown-p d-flex flex-wrap text-justify mt-0 pt-0"
                          //     style={{fontSize: "16px",maxHeight: "350px",overflow: "auto",whiteSpace: "initial",display: "none"}}
                          //   >
                          //     {Reader_viewTime}
                          //     {" (hh:mm:ss)"}: {convertToHHMMSS(viewDocTime)}
                          //     {/* {viewDocTime === 1 ? "Min" : "Mins"} */}
                          //   </p>
                          // </li>
                        }
                      </ul>
                    </li>
                    {documentLevelRestriction && (
                      <li className="rpdFont dropdown nav-item res-w100">
                        <div
                          className="form-check checkbox-theme justify-content-center"
                          style={{ textAlign: "center", paddingTop: "0.3rem", paddingLeft: "0px" }}
                        >
                          <input
                            className="chkAllowReaders"
                            type="checkbox"
                            value={localPageLevelRestriction}
                            checked={localPageLevelRestriction}

                            id="robot"
                            onChange={(e) => { handleChkChange(e) }}
                          />
                          <label className="form-check-label" htmlFor="rememberMe" style={{ paddingBottom: "2px", verticalAlign: "text-bottom" }}>
                            {translationsMap.Reader_AllowedPagesOnly}
                          </label>
                        </div>
                      </li>
                    )}
                    {/* RShield - capture detection warning. Last item in the
                        ribbon, right aligned by ms-auto, and centred by the
                        ribbon itself like the icons to its left. */}
                    <CaptureWarning {...documentProtection.captureWarningProps} />
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        <>
          {!pageLevelRestriction && (
            <Container
              id="imgContainer"
              ref={containerRef}
              className={
                // 'no-visual-search' sets pointer-events:none on the whole container.
                // For Excel (OnlyOffice iframe), we MUST exclude it or every click is blocked.
                isExcelFile
                  ? (zoomClassFull != "" ? "d-flex " + zoomClassFull : "d-flex")
                  : (zoomClassFull != "" ? " no-visual-search d-flex " + zoomClassFull : "no-visual-search d-flex")
              }
              style={
                documentProtection.active ? { position: "relative" } : undefined
              }
            >
              {/* Browser-Based Document Protection - dynamic watermark overlay. */}
              <Watermark {...documentProtection.watermarkProps} />
              {imgURLData != "" && !isExcelFile && (
                // RShield - while the view is protected the page image is not
                // rendered at all, so its base64 data cannot be read out of the
                // Elements panel. A placeholder of the same size holds the
                // layout (and the overlay's bounds) steady meanwhile.
                documentProtection.hideContent ? (
                  <div
                    className="dp-image-placeholder"
                    style={{
                      width: pageWidthValue,
                      height: pageHeightValue,
                    }}
                  />
                ) : (
                  <img
                    className={zoomClass + " rm-trans"}
                    ref={pageRef}
                    src={`data:image/png;base64,${imgURLData}`}
                    alt={imgURLData == "" ? "Page Not Found" : ""}
                    align="left"
                    style={{
                      width: pageWidthValue,
                      height: pageHeightValue,
                      //marginLeft: pageWidthLeftValue,
                    }}
                    onLoad={async (e) => {
                      const el = e.currentTarget;
                      if (el && el.decode) {
                        try {
                          await el.decode().then(() => {
                            updateDimensions();
                          });
                        } catch { }
                      }
                    }}

                  //onLoad={updateDimensions}
                  />
                )
              )}{isExcelFile && (
                <SimpleExcelViewer
                  ref={excelViewerRef}
                  key={`${documentId}-${currentpage}`}
                  documentId={documentId}
                  pageNumber={currentpage}
                  openId={openId}
                  userId={loginEmailAddress}
                  /* Excel edit is opt-in per reader email (AppContext).
                     Use ONLY the reader's own login email - never the sender
                     fallback - so L1/unauthorized readers (no verified email,
                     or an email not configured) get no Edit button and Enter
                     editing stays inert. */
                  excelPayload={
                    excelPayloadByPageRef.current[currentpage - 1]
                  }
                  onDirtyChange={(dirty) => {
                    // Tracked so page navigation can warn before the viewer
                    // remounts and unsaved edits are lost.
                    excelEditsDirtyRef.current = !!dirty;
                  }}
                  height="calc(100vh - 170px)"
                  zoomScale={excelZoomScale}
                  onLocked={() => {
                    // The Excel file is locked/encrypted — fall back to the
                    // existing PDF rendering flow by treating this page as a
                    // non-Excel page.
                    console.log("[DocumentRPD] Excel file is locked/encrypted, falling back to PDF flow.");
                    setIsExcelFile(false);
                  }}
                  onSaveSuccess={(msg) => {
                    // Show the save-success toast on the MAIN DocumentRPD page
                    // via its top-level Alert (not clipped inside the viewer).
                    setAlertType("sucess");
                    setAlertMsg(msg || "Data saved successfully");
                    setTimeout(() => {
                      setAlertType("");
                      setAlertMsg("");
                    }, 6000);
                  }}
                />
              )}
              {!isExcelFile && showTab && idLeakersType !== "Cipher Text Only" && (
                <div
                  id="floatingText"
                  //key={floatingKey}
                  ref={floatingRef}
                  className="watermarkParent"
                  style={{
                    width: pageWidthValue,
                    height: pageHeightValue,
                    marginLeft: pageWidthLeftValue,
                  }}
                  dangerouslySetInnerHTML={{ __html: identifyLeakerText }}
                />
              )}
            </Container>
          )}
        </>
        {pageLevelRestriction && renderRestrictedWhitePage()}

        {/* Request Access popup - scoped to page view area only */}
        {showRestrictedPopup === true && pageLevelRestriction &&
          (() => {
            const currentPageNum = parseInt(currentpage, 10);
            const matched = Array.isArray(documentPageLevelRestrictionRequested)
              ? documentPageLevelRestrictionRequested.find(
                (r) =>
                  r &&
                  Array.isArray(r.pages) &&
                  r.pages.map((p) => parseInt(p, 10)).includes(currentPageNum)
              )
              : null;
            const status = matched?.status;
            const requestedMatch = matched?.pages?.includes(currentPageNum);
            const declinedMatch = matched?.rejectedPages?.includes(currentPageNum);
            const currentPageStatus = pageRequestStatus[currentpage];
            return (
              <div
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: "rgba(128, 128, 128, 0.11)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  zIndex: 10,
                }}
              >
                <div style={{
                  background: "#fff",
                  borderRadius: "8px",
                  boxShadow: "0 2px 16px rgba(0,0,0,0.18)",
                  padding: "1.5rem 2rem",
                  maxWidth: "400px",
                  width: "85%",
                  margin: "7rem 0 0 0"
                }}>
                  <div className="mt-4 mb-3 justify-content-center d-flex">
                    <img src={`data:image/png;base64,${imgLockData}`} alt="Lock"
                      style={{ width: "80px", height: "80px" }} />
                  </div>
                  {((isLevelOne && (currentPageStatus !== "Pending" && currentPageStatus !== "Declined" && !isVerified)) || (!isLevelOne && (status !== "Pending" && status !== "Declined" && status !== "Partially Declined")))
                    && <h5 className="text-center my-4 res-font14 rpdFont rd-text">
                      <span className="text-warn-text text-wrap-custom">
                        {translationsMap.Reader_YouDontHaveAccess}
                      </span>
                    </h5>}
                  {/*
                Decide what to show below the "you don't have access" message:
                - If the current page already has a Pending request → status message.
                - If the current page already has a Rejected request → status message.
                - Else, show the Request Access button (still gated by loginEmail
                and requestAccessDone for the no-prior-request case).
                */}
                  {(() => {
                    if ((requestedMatch && !declinedMatch) || currentPageStatus === "Pending") {
                      return (
                        <h6
                          className="text-center my-3 res-font14 rpdFont rd-text text-wrap"
                          style={{ color: "#040921" }}
                        >
                          {translationsMap.Reader_YourRequestIsUnderReview}
                        </h6>
                      );
                    }
                    if ((declinedMatch === "true" || declinedMatch === true) || currentPageStatus === "Declined") {
                      return (
                        <h6
                          className="text-center my-3 res-font14 rpdFont rd-text text-wrap"
                          style={{ color: "#040921" }}
                        >
                          {translationsMap.Reader_YourRequestIsDeclined}
                        </h6>
                      );
                    }
                    // No prior request for this page — fall back to the original
                    // Request Access button (hidden when no loginEmail or when the
                    // user has already submitted a request in this session).
                    if (isVerified) {
                      return (
                        <>
                          <div
                            className="rpdFont d-flex flex-column justify-content-center"
                            style={{ color: "#040921" }}
                          >
                            <p className="text-center mb-3 font-18px res-font14 text-wrap">
                              {translationsMap.Reader_YourLevelOneRequestIsApproved}
                            </p>
                          </div>

                          <div className="rpdFont input-group mb-3 pb-2">
                            <div className="input-group-append">
                              <span className="input-group-text rp-text">
                                <i
                                  className="material-icons"
                                  style={{ fontSize: "22px", color: "#fff" }}
                                >
                                  mail
                                </i>
                              </span>
                            </div>

                            <input
                              type="text"
                              className="rpdFont form-control input_user"
                              placeholder={translationsMap.Reader_Email}
                              value={pageEmails[currentpage] || ""}
                              onChange={handleVerifyEmail}
                              autoComplete="new-password"
                            />
                          </div>

                          <div className="rpdFont input-group mb-3">
                            <div className="input-group-append">
                              <span className="input-group-text rp-text">
                                <i
                                  className="material-icons"
                                  style={{ fontSize: "22px", color: "#fff" }}
                                >
                                  key
                                </i>
                              </span>
                            </div>

                            <input
                              type={PasscodeType}
                              className="rpdFont form-control input_pass"
                              placeholder={translationsMap.Reader_Passcode}
                              onChange={handlePasscode}
                              autoComplete="new-password"
                            />

                            <div className="input-group-btn">
                              <a onClick={togglePassword} style={{ cursor: "pointer" }}>
                                {PasscodeType === "password" ? (
                                  <span className="material-icons passwordShow">
                                    visibility_off
                                  </span>
                                ) : (
                                  <span className="material-icons passwordShow">
                                    remove_red_eye
                                  </span>
                                )}
                              </a>
                            </div>
                          </div>

                          <div className="rpdFont d-flex justify-content-center mt-3">
                            <button
                              type="button"
                              className="rpdFont btn login_btn w-md-75 rp-btn"
                              style={{ lineHeight: "1.6", fontSize: "17px" }}
                              onClick={verifyCode}
                            >
                              {translationsMap.Reader_Authorize}
                            </button>
                          </div>
                        </>
                      );
                    }

                    else if (!isPageUnderReview && !isPageDeclined && allowAccessRequest) {
                      return (
                        <div className="d-flex justify-content-center align-items-center gap-2 flex-wrap">
                          {isLevelOne && (<div className="rpdFont input-group request-access-input-group">
                            {/* <div className="input-group-append">
                          <span className="input-group-text rp-text request-access-icon">
                            <i className="material-icons request-access-mail-icon" style={{ height: "40px !important" }}>
                              mail
                            </i>
                          </span>
                        </div> */}
                            <div className="input-group-append">
                              <span className="input-group-text rp-text">
                                <i className="material-icons" style={{ fontSize: "22px", color: "#fff" }}>
                                  mail
                                </i>
                              </span>
                            </div>
                            <input
                              type="text"
                              className="rpdFont form-control input_user request-access-icon"
                              placeholder={translationsMap.Reader_RPostEmail}
                              value={currentEmail}
                              onChange={(e) => handleVerifyEmail(e)}
                              autoComplete="new-password"
                              style={{ height: "40px !important" }}
                              disabled={submittedRequestEmail !== ""}
                            />
                          </div>
                          )}
                          <button
                            type="button"
                            className="btn btn-secondary  px-4"
                            style={{ background: "#040921" }}
                            disabled={isLevelOne && currentEmail.trim().length === 0}
                            onClick={isLevelOne ? GenerateLevelOnePasscode : handleRequestAccess}
                          >
                            {translationsMap.reader_RequestAccess}
                          </button>
                        </div>
                      );
                    }
                    return null;
                  })()}
                </div>
              </div>
            );
          })()}
      </main>


      {/* Modal popup */}
      {open === true && (
        <div
          backdrop="static"
          className="rpdFont modal"
          id="myModal1"
          style={{
            display: "block",
            backgroundColor: "rgb(114 114 114 / 28%)",
            zIndex: "999999",
          }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div
            className="rpdFont modal-dialog modal-dialog-centered modal-customelg"
            style={{ background: "transparent" }}
          >
            <div className="modal-content">
              <div className="modal-body d-flex flex-column">
                <div className="mt-4 mb-3 justify-content-center d-flex">
                  <img src={timerpng} alt="Time" className="check" />
                </div>

                <h5
                  className="rpdFont text-center my-2 res-font14"
                  style={{ color: "rgb(4, 9, 33)" }}
                >
                  {translationsMap.Reader_RPDYouHaveBeenInactive}
                </h5>
                <h6
                  className="rpdFont text-center mb-1"
                  style={{ color: "rgb(4, 9, 33)", fontSize: "17px" }}
                >
                  {translationsMap.Reader_ContinueReadingDocument}
                </h6>
                {/* <label id="spntimer" className="text-center" style={{paddingLeft:"50px"}}>4 minute(s) & 59 second(s)</label> */}
                <label
                  id="spntimer"
                  className="text-center mb-1"
                  style={{
                    color: "rgb(4, 9, 33)",
                    fontSize: "17px",
                  }}
                >
                  {translationsMap.Reader_YouWillbeLoggedOutIn}{" "}
                  {minutesVal +
                    " " +
                    translationsMap.Reader_minutesSmall +
                    " " +
                    secondsVal +
                    " " +
                    translationsMap.Reader_secondsSmall}
                </label>
                <div className="mt-3 mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{ background: "rgb(4, 9, 33)" }}
                    onClick={handleToClose}
                  >
                    {translationsMap.Reader_Continue}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      <div
        className="rpdFont modal "
        id="myModal2"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="rpdFont modal-dialog modal-dialog-centered modal-customelg">
          <div className="modal-content">
            <div className="modal-header d-flex justify-content-end mt-1 border-0 pb-0">
              <button
                type="button"
                className="btn btn-outline-danger modalclose rpdclose"
                data-bs-dismiss="modal"
              >
                {" "}
                <span className="material-icons font-20">
                  highlight_off
                </span>{" "}
              </button>
            </div>
            <div className="modal-body">
              <div className="mb-3 justify-content-center d-flex">
                <img
                  src={
                    VotedValue === -1
                      ? likeUnlike
                      : VotedValue === 0
                        ? Unlike
                        : likelike
                  }
                  alt=""
                  className="modalcheck"
                />
              </div>
              <h5
                className="text-center mt-4 mb-2"
                style={{
                  color: "#040921",
                  fontSize: "1.3rem",
                  fontWeight: "600",
                }}
              >
                {translationsMap.Reader_ConfirmYourVote}
              </h5>
              <h6
                className="text-center mb-4"
                style={{ color: "#040921", fontSize: "17px" }}
              >
                {translationsMap.Reader_OnlyVoteOnce}
              </h6>
              <div className="pt-2 mb-3 justify-content-center d-flex">
                <button
                  type="button"
                  disabled={VotedValue === -1 ? false : true}
                  className="btn btn-success d-flex align-items-center px-4"
                  style={{ backgroundColor: "rgb(58, 177, 109) !important" }}
                  data-bs-dismiss="modal"
                  onClick={(e) => handleToLike(e)}
                >
                  <span className="material-icons me-1"> thumb_up </span>{" "}
                  {translationsMap.Reader_Like}
                </button>
                <button
                  type="button"
                  disabled={VotedValue === -1 ? false : true}
                  className="btn btn-danger ms-4 d-flex align-items-center px-3"
                  style={{ backgroundColor: "#c3272e" }}
                  data-bs-dismiss="modal"
                  onClick={(e) => handleToUnLike(e)}
                >
                  <span className="material-icons me-1"> thumb_down </span>{" "}
                  {translationsMap.Reader_Dislike}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className="rpdFont modal"
        id="replyToOwnerModel"
        onContextMenu={(e) => e.preventDefault()}
      >
        <div className="modal-dialog modal-dialog-centered modal-customelg">
          <div className="modal-content">
            <div className="modal-header pb-2">
              <h5 className="Rreply-text"> {translationsMap.Reader_ReplyToDocument} </h5>
              <button
                type="button"
                className="btn btn-outline-danger modalclose rpdclose"
                data-bs-dismiss="modal"
                id="closeReplytoOwner"
                onClick={(e) => sendToemailClose(e)}
              >
                <span className="material-icons font-20">highlight_off</span>{" "}
              </button>
            </div>

            <div className="rpdFont modal-body">
              <div className="input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rpd-group-text">
                    <i className="material-icons" style={{ fontSize: "22px" }}>
                      contact_mail
                    </i>
                  </span>
                </div>
                <input
                  id="txtToAddress"
                  readOnly={true}
                  type="text"
                  className="rpdFont form-control input_user"
                  placeholder={translationsMap.Reader_ToAddress}
                  value={allowResponsesTo}
                  onChange={(e) => setAllowResponsesTo(e.target.value)}
                ></input>
              </div>

              <div className="input-group mb-3 pb-2">
                <div className="input-group-append">
                  <span className="input-group-text rpd-group-text">
                    <i className="material-icons" style={{ fontSize: "22px" }}>
                      subject
                    </i>
                  </span>
                </div>
                <input
                  id="txtSubject"
                  type="text"
                  name="subject"
                  className="rpdFont form-control input_user"
                  placeholder={translationsMap.Reader_Subject}
                  value={replySubject}
                  onChange={(e) => setreplySubject(e.target.value)}
                ></input>
              </div>

              <div>
                <textarea
                  name="replymessage"
                  className="rpdFont form-control font-w600 rplycontrol"
                  rows="4"
                  style={{ resize: "none" }}
                  placeholder={translationsMap.Reader_Message}
                  value={replymessage}
                  onChange={(e) => setreplymessage(e.target.value)}
                ></textarea>
              </div>

              <div className="pt-2 my-3 justify-content-center d-flex">
                <button
                  type="button"
                  disabled={sendEmailButton}
                  className="btn btn-secondary cpx-5 cpy-1 w-50 rp-btn"
                  style={{
                    backgroundColor: "#040921 !important",
                    color: "white !important",
                    border: "1px solid #040921",
                  }}
                  onClick={(e) => sendToEmail(e)}
                >
                  {translationsMap.Reader_Send}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
      {senderEmailAddress.indexOf("@xerox.com") === -1 && (
        <div
          className={
            zoomClassFull != ""
              ? "mobile-footer " + zoomClassFull
              : "mobile-footer"
          }
          onClick={(e) => hidemenu(show)}
        >
          <Footer
            Reader_GeneralTermsFooter={translationsMap.Reader_GeneralTermsFooter}
            Reader_LegalNotices={translationsMap.Reader_LegalNotices}
            Reader_ClickServiceLevelTerms={translationsMap.Reader_ClickServiceLevelTerms}
            Reader_Patent={translationsMap.Reader_Patent}
            Reader_OtherService={translationsMap.Reader_OtherService}
            className="pdf-footer"
            onContextMenu={(e) => e.preventDefault()}
          ></Footer>
        </div>
      )}

      {modelopen === true && (
        <div
          className="rpdFont modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <h5
                  className="text-center my-4 res-font14"
                  style={{ color: "#040921 !important" }}
                >
                  {modelMessage}
                </h5>

                <div className="mb-3 justify-content-center d-flex">
                  <button
                    type="button"
                    className="btn btn-secondary w-50 py-2"
                    data-bs-dismiss="modal"
                    style={{
                      background: "#040921",
                    }}
                    onClick={modelPopupToClose}
                  >
                    {translationsMap.Reader_OK}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {pageRestrictedFlag == true && (
        <div
          className="rpdFont modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex align-items-center flex-column justify-content-center bg-white" >
                  <img className="mb-4"
                    src={`data:image/png;base64,${imgLockData}`}
                    //src="https://cdn-icons-png.flaticon.com/512/12478/12478122.png"
                    width="80" height="80" alt="File lock free icon" title="File lock free icon"></img>
                  <h6 className="imgLockText">{translationsMap.Reader_YouDontHaveAccessToRequested}</h6>
                  <div className="mb-3 justify-content-center d-flex">
                    <button
                      type="button"
                      className="btn btn-secondary py-2"
                      data-bs-dismiss="modal"
                      style={{
                        background: "#040921",
                        width: "60px"
                      }}
                      onClick={modelPopupYouDontHaveAccessClose}
                    >
                      {translationsMap.Reader_OK} {" ("}{pageRestrictedCount}{")"}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isNoUnitsPopup == true && (
        <div
          className="rpdFont modal"
          id="myModal1"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-body">
                <div className="d-flex align-items-center flex-column justify-content-center bg-white" >
                  <img className="mb-4"
                    src={`data:image/png;base64,${imgLockData}`}
                    //src="https://cdn-icons-png.flaticon.com/512/12478/12478122.png"
                    width="80" height="80" alt="File lock free icon" title="File lock free icon"></img>
                  <p className="rpdFont text-center font-1rem text-nowrap1 rd-text">
                    The document is not available to view at this time. Please contact the document owner for additional information.
                  </p>
                  <div className="mb-3 justify-content-center d-flex">
                    <button
                      type="button"
                      className="btn btn-secondary py-2"
                      data-bs-dismiss="modal"
                      style={{
                        background: "#040921",
                        width: "60px"
                      }}
                      onClick={modelPopupNoUnitsClose}
                    >
                      {translationsMap.Reader_OK}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {showPrintLimitPopup === true && (
        <div
          className="rpdFont modal"
          id="printLimitModal"
          style={{ display: "block", backgroundColor: "#8080801c" }}
          onContextMenu={(e) => e.preventDefault()}
        >
          <div className="modal-dialog modal-dialog-centered modal-customelg">
            <div className="modal-content">
              <div className="modal-header d-flex  mt-1  pb-0">
                <h5 className="text-center" style={{ fontWeight: "600" }}>Alert</h5>
                <button
                  type="button"
                  className="btn btn-outline-danger modalclose rpdclose"
                  onClick={() => setShowPrintLimitPopup(false)}
                >
                  <span className="material-icons font-20">highlight_off</span>
                </button>
              </div>
              <div className="modal-body">
                <p className="rpdFont text-center font-1rem rd-text">
                  {printLimitMessage}
                </p>
                {!isLeftOutMessage && (
                  <div className="mb-1 justify-content-center d-flex">
                    <button className="agree py-2 w-50" onClick={() => {
                      setShowPrintLimitPopup(false)
                    }}>
                      {"OK"}
                    </button>
                  </div>
                )}
                {isLeftOutMessage && (
                  <>
                    <div className="mb-1 justify-content-center d-flex" style={{ gap: '2rem' }}>
                      <button className="disagree py-2" onClick={() => setShowPrintLimitPopup(false)}>
                        {"Cancel"}
                      </button>
                      <button className="agree py-2" onClick={onProceedHandler}>
                        {"Proceed"}
                      </button>
                    </div>
                  </>
                )
                }
              </div>
            </div>
          </div>
        </div>
      )}


      {/* Request Access popup - always mounted; RequestAccess controls its own visibility via onShow */}
      <RequestAccess
        onConfirmRequestAccess={onConfirmRequestHandler}
        onCancel={onRequestAccessCancel}
        ref={requestAccessRef}
        Email_RequestHasBeenSent={translationsMap.Email_RequestHasBeenSent}
        Email_PleaseWaitForApproval={translationsMap.Email_PleaseWaitForApproval}
        Reader_OK={translationsMap.Reader_OK}
        docSenderAddress={senderEmailAddress}
        documentLevelRestrictionDetails={documentLevelRestrictionDetails}
        onRequestSuccess={setStatusOfSubmittedRequestEmail}
      ></RequestAccess>

      <div id="dvframe" style={{ display: "none" }}></div>
    </>
  );
}
export default DocumentNew;
